import React, { useState, useEffect, useCallback, useRef } from 'react';
import BoardingPass from './BoardingPass';
import BagTag from './BagTag';
import LogoutModel from './LogoutModel';
import DocumentVerificationModal from './DocumentVerificationModal';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { loginCredential, searchCredential, bagCredential, selectedpassengerCredential, redirectToPageCredentials, docVerifyCredential, printerPopupSearchPageCredential, moduleAndLoginDivDisabled } from '../ReduxState';
import { fncCheckInPassengerApi, fncUndoCheckInPassengerApi, fncGetBookingFromState, fncSaveChangesApi, fncGetBoardingPassApi, fncUnAssignPassengerSeats, fncRemoveBaggage, fncCheckInBaggageApi, FncSearchApi, fncEditPassengerContactDetails, fncAddPassengerContactDetails, fncSendSMS, fncMBPDetails, fncSendEmail, fncSendWhatsapp, fncGetAllFlyBigSchedules, fncLogJSPMPrint, fncSitaFlexGetTokenOrStatus, fncSitaFlexPrintCall } from '../Utility/ApiCall.js'
import { ToastContainer, toast } from 'react-toastify';
import {
  fncAssignSearchedCheckboxes, fncGetServiceNameFromCode, fncCheckFlightReferenceOnServicePage, monthNames, fncBagStatus, fncBagCount, fncSeqNo, fncSSR, shortcutKeyForPage, shortcutKeys, printerForBoardingPass, isInternationalFlight, isInternationalSeg, checkinModule, haveTravelDocs, getBagtagPrintData, fncCheckIfTokenIsExpired, fncCheckSearchedFlightDetailsEmpty, checkIfFlybigFlight,
  removeSimilarBags, fncFocusElementDependsOnPathLocation, shortcutKeysForPageNavigation, shortcutKeysforHumburgerMenu, isValidEmail, isValidIndianPhone, sanitizePhone, getZPLCommandForBoardingPass, getZPLCommandForDirectBagTag, getTSCPLCommandForDirectBagTag, getZPLCommandForConnectingBagTag, getTSCPLCommandForConnectingBagTag, getCheckedBaggageKeys, generateReferenceStringForBoardingPass, generateReferenceStringForBagTag
} from '../Utility/CommonFun.js'; //printersConfigBP, printersConfigBT
import { confirmAlert } from 'react-confirm-alert'; // Import
import MultiSelect from "react-multi-select-component";
import { Button, Modal } from 'react-bootstrap';
import ReactTooltip from "react-tooltip";
import * as moment from 'moment';
import html2canvas from "html2canvas";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import FocusLock from "react-focus-lock";

function Finalize({ handleSideMenu }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [Boardingpopup, setBoardingpopup] = useState(false);
  const [Bagtagpopup, setBagtagpopup] = useState(false);
  const passengerRef = useRef([]);
  const checkInPassengersOrSaveChangesRef = useRef(null);
  const notify = (e, close = 5000) =>
    toast.error(e, {
      position: "top-right",
      autoClose: close,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifySuccess = (e, close = 5000) =>
    toast.success(e, {
      position: "top-right",
      autoClose: close,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  let segCount = 0;
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [triggerModal, settriggerModal] = useState(false);
  const [btCommBP, setBtCommBP] = useState(null);
  const [btCommBT, setBtCommBT] = useState(null);
  const Location = useSelector(state => state.login.Location);
  const initialBagCount = useSelector(state => state.search.initialBaggageCount);
  console.log('Location', Location);
  const stSearchedRecordData = useSelector(state => state.search.SearchedRecordData);
  const printersConfigBP = useSelector(state => state.login.printersConfigBP);
  const printersConfigBT = useSelector(state => state.login.printersConfigBT);
  const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
  const isBagAddedInState = useSelector(state => state.search.isBagAdded);
  const isJumpSeatSelected = useSelector(state => state.search.isJumpSeatSelected);
  // const isInternationalDocVerified = useSelector(state => state.search.isInternationalDocumentVerified);
  const SearchedSelectedPassengerData = useSelector(state => state.selectedpassenger.SelectedPassengerData);
  const UserName = useSelector(state => state.login.UserName);
  const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
  // const isFlyBig = useSelector(state => state.login.isFlyBigRequired);
  const [AddBags, setAddBags] = useState([{}]);
  const [modalShow, setModalShow] = useState(false);
  const handleCloseshowErrorPopup = () => setModalShow(false);
  const [modalShowBagTag, setModalShowBagTag] = useState(false);
  const [CheckInBags, setCheckInBags] = useState(false);
  const [UnCheckInBags, setUnCheckInBags] = useState(true);
  const [saveChanges, setSaveChanges] = useState(true);
  const [UnCheckInAllowed, setUnCheckInAllowed] = useState(true);
  const [CheckInPassenger, setCheckInPassenger] = useState(true);
  const [isBoardingPassPrint, isBoardingPassPrintEnabled] = useState(true);
  const [isBagTagPrint, isBagTagPrintEnabled] = useState(true);
  const [BPVisibility, setBPVisibility] = useState(false);
  const [BoardingPassDataForTransfer, setBoardingPassDataForTransfer] = useState([]);
  const [UnCheckButton, setUnCheckButton] = useState(true);
  const [passengersListToUncheck, setPassengersListToUncheck] = useState([]);
  const [selectedPassengerDropdown, setSelectedPassengerDropdown] = useState([]);
  const [selectAllBagsToPrint, setSelectAllBagsToPrint] = useState(false);
  const [selectAllBPToPrint, setSelectAllBPToPrint] = useState(false);
  const [printingBoardingPassFrom, setPrintingBoardingPassFrom] = useState("");
  const [printBagTagFrom, setPrintBagTagFrom] = useState('');
  const [bgTag, setBgTagPrint] = useState(false);
  const [bpPrint, setBpPrint] = useState(false);
  const [passengersForSMSPush, setPassengersForSMSPush] = useState([]);
  const [selectAllPaxForSMS, setSelectAllPaxForSMS] = useState(false);
  const selectedModule = useSelector(state => state.login.Module);
  const docVerified = useSelector(state => state.docVerify.documentsVerified);
  const [sendSMSEnabled, setsendSMSEnabled] = useState(false);
  const [sendEmailEnabled, setsendEmailEnabled] = useState(false);
  const [sendWhatsappEnabled, setsendWhatsappEnabled] = useState(false);
  const [mbpGenerated, setmbpGenerated] = useState(false);
  const [isphoneNumberPresent, setisphoneNumberPresent] = useState(false);
  const [passengerUncheckDone, setPassengerUncheckDone] = useState(false);
  const [submitButton, setSubmitButton] = useState(false);
  const [st_UnCheckPassenger, setUnCheckPassenger] = useState([
    {
      IsChecked: false,
      Id: "UNASSIGNSEAT",
      Name: 'Remove Seat(s)'
    },
    {
      IsChecked: false,
      Id: "REMOVEBAGS",
      Name: 'Remove baggage(s)'
    }
  ]);
  const [availablePrinters, setAvailablePrinters] = useState([]);
  const [availableBluetoothPrinters, setavailableBluetoothPrinters] = useState([]);
  const lrtBagType = useSelector(state => state.search.lrtBagTypeForPassenger);
  const selectedMode = useSelector(state => state.printMode.selectedMode);
  // const selectedprintMode = useSelector(state => state.printMode.selectedMode);
  const sitaFlexLocationId = useSelector(state => state.printMode.sitaFlexLocationId);
  const [clientInfo, setClientInfo] = useState('');
  console.log('added bags', AddBags);

  useEffect(() => {
    if (fncCheckSearchedFlightDetailsEmpty(SearchedFlightDetails)) {
      history.push('/Search');
    }
  });

  const doClose = async () => {
    if (btCommBP) {
      btCommBP.close();
      setBtCommBP(null);
    }
    if (btCommBT) {
      // alert("Closing btCommBT...");
      btCommBT.close();
      setBtCommBT(null);
    }

  };

  useEffect(() => {
    // alert('clientInfo',clientInfo);
    if (clientInfo.includes('Android')) {
      const localStoragePrinters = localStorage.getItem('Printers');
      // alert(localStoragePrinters)
      if (localStoragePrinters !== null) {
        const printers = JSON.parse(localStoragePrinters);
        const boardingpassPrinter = printers.boardingPass;
        const bagTagPrinter = printers.bagTag;
        if (boardingpassPrinter && boardingpassPrinter.address) {
          // alert(boardingpassPrinter)
          const newBtComm = new JSPM.BTComm(boardingpassPrinter.address, 1);
          newBtComm.connect().then(() => {
            // alert("COMM OPEN! for BP\r\n");
            setBtCommBP(newBtComm);
          }).catch(err => {
            const errorMessage = err?.message || JSON.stringify(err) || String(err);
            // alert("Connection failed: " + errorMessage + "\r\n");
          });
        }
        if (bagTagPrinter && bagTagPrinter.address) {
          // alert(bagTagPrinter)
          const newBtCommBT = new JSPM.BTComm(bagTagPrinter.address, 1);
          newBtCommBT.connect().then(() => {
            // alert("COMM OPEN! for BT\r\n");
            setBtCommBT(newBtCommBT);
          }).catch(err => {
            const errorMessage = err?.message || JSON.stringify(err) || String(err);
            // alert("Connection failed: " + errorMessage + "\r\n");
          });
        }
      }
    }
  }, [clientInfo]);

  useEffect(() => {
    if (btCommBP) {
      btCommBP.onDataReceived = function (data) {
        // _this.dataReceived += "< " + data + "\r\n";
        alert("Data Received in bp:" + data);
      }
    };
  }, [btCommBP]);

  useEffect(() => {
    if (btCommBT) {
      btCommBT.onDataReceived = function (data) {
        // _this.dataReceived += "< " + data + "\r\n";
        alert("Data Received in bt:" + data);
      }
    };
  }, [btCommBT]);

  useEffect(() => {
    if (selectedMode !== "Native") return;
    var wlPort = (new URLSearchParams(window.location.search)).get('wlport');
    debugger
    if (wlPort == null) wlPort = 27443;

    JSPM.JSPrintManager.license_url = process.env.REACT_APP_JSPM_LICENCE_URL;
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start(true, 'localhost', wlPort);
    JSPM.JSPrintManager.WS.onStatusChanged = function () {
      if (jspmWSStatus()) {
        console.log('JSPM connected');
        JSPM.JSPrintManager.getClientAppInfo().then((e) => {
          let jsonData = JSON.parse(e);
          let cInfo = "Version: " + jsonData.version + " OS: " + jsonData.os + " (" + jsonData.arch + ")";
          setClientInfo(jsonData.os); //Android
          console.log('cinfo', cInfo)
        }).catch((e) => console.error(e))
      } else {
        console.log('JSPM not connected');
        document.getElementById("showAndHideSpinner").style.display = "none";
      }
    }
    // Handle JSPM errors
    JSPM.JSPrintManager.WS.onError = (event) => {
      console.error('JSPM error:', event);
    };

    // Cleanup on unmount
    return () => {
      JSPM.JSPrintManager.stop();
    };
  }, [])

  //Check JSPM WebSocket status
  function jspmWSStatus() {
    if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
      console.log('JSPrintManager (JSPM) is installed');
      return true;
    }
    else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
      console.log('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
      return false;
    }
    else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
      console.log('JSPM has blocked this website!');
      return false;
    }
  }

  useEffect(() => {
    if (selectedPassengerDropdown.length > 0) {
      setUnCheckButton(false);
    } else {
      setUnCheckButton(true);
    }
  }, [selectedPassengerDropdown]);

  function fncSelectSMSPax(e, item) {
    // console.log('fncSelectSMSPax e.target.checked', e.target.checked);
    const smsPax = [...passengersForSMSPush];
    smsPax.forEach(pSms => {
      if (pSms.passengerKey === item.passengerKey) {
        pSms.isChecked = e.target.checked;
      }
    });
    if (!smsPax.every(p => p.isChecked)) {
      setSelectAllPaxForSMS(false);
    } else {
      setSelectAllPaxForSMS(true);
    }
    setPassengersForSMSPush(smsPax);
  }

  function fncSelectAllPaxForSMS(e) {
    const smsPax = [...passengersForSMSPush];
    // const allPaxField = smsPax.every(s => s.phone);
    // if (allPaxField) {
    smsPax.forEach(pSms => {
      pSms.isChecked = e.target.checked;
    });
    setSelectAllPaxForSMS(e.target.checked);
    setPassengersForSMSPush(smsPax);
    // }
  }

  function fncPhone(e, item) {
    // debugger;
    const phoneNumber = e.target.value.replace(/[^0-9]/g, '');
    const indianMobileRegex = /^[6|7|8|9]{1}[0-9]{9}$/;
    if (indianMobileRegex.test(phoneNumber) || phoneNumber.length <= 12) {
      const smsPax = [...passengersForSMSPush];
      smsPax.forEach(p => {
        if (p.passengerKey === item.passengerKey) {
          p.phone = phoneNumber;
        }
      });
      setPassengersForSMSPush(smsPax);
    }
  }

  function fncEmail(e, item) {
    const email = e.target.value;
    // const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    // if (emailReg.test(email)) {
    const smsPax = [...passengersForSMSPush];
    smsPax.forEach(p => {
      if (p.passengerKey === item.passengerKey) {
        p.email = email;
      }
    });
    setPassengersForSMSPush(smsPax);
    // }
  }

  const sendBP = async () => {
    const updateresult = await updateAddress();
    if (updateresult === undefined) {
      if (sendEmailEnabled) {
        let emailregex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let passengersToSendEmail = passengersForSMSPush.length > 1
          ? (passengersForSMSPush.every(p => p.isChecked && p.email !== '' && emailregex.test(p.email.toLowerCase()))
            ? passengersForSMSPush.filter(p => p.isChecked && p.email !== '' && emailregex.test(p.email.toLowerCase())) : []) :
          passengersForSMSPush.filter(p => p.email !== '' && emailregex.test(p.email.toLowerCase()));

        if (passengersForSMSPush.length === 1) {
          passengersToSendEmail = passengersForSMSPush.filter(p => p.email !== '' && emailregex.test(p.email.toLowerCase()));
        } else if (passengersForSMSPush.length && passengersForSMSPush.length > 1) {
          passengersToSendEmail = passengersForSMSPush.filter(p => p.isChecked && p.email !== '' && emailregex.test(p.email.toLowerCase()));
          if (passengersToSendEmail.length !== passengersForSMSPush.length && (passengersForSMSPush.filter(p => p.isChecked && p.email === '').length)) {
            notify('Valid email id is not provided for selected passenger(s)');
            return;
          }
        }
        const { recordLocator, contacts } = SearchedFlightDetails;
        if (passengersToSendEmail.length) {
          const sendEmailRequest = {
            recordLocator: recordLocator,
            passengerNameList: [],
            segmentKeyList: [],
            format: 1,
            type: 1,
            email: passengersToSendEmail.length ? passengersToSendEmail[0].email : contacts.emailAddress ? contacts.emailAddress : ''
            // email: contacts.emailAddress ? contacts.emailAddress : passengersToSendEmail.length ? passengersToSendEmail[0].email : ''
          };
          debugger
          SearchedFlightDetails.journeys.forEach((j) => {
            j.segments.filter(seg => seg.IsSelected).forEach(s => {
              // const dte = moment(s.designator.departure).format("YYYYMMDD");
              sendEmailRequest.segmentKeyList.push(`${moment(s.designator.departure).format("YYYYMMDD")}${s.designator.origin}${s.designator.destination}`)
              passengersToSendEmail.forEach(pse => {
                sendEmailRequest.passengerNameList.push({
                  title: pse.name.title ? pse.name.title : '',
                  suffix: "",
                  firstName: pse.name.first ? pse.name.first : '',
                  middleName: pse.name.middle ? pse.name.middle : '',
                  lastName: pse.name.last ? pse.name.last : ''
                })
              })
            })
          })

          const sendEmailResult = await fncSendEmail(sendEmailRequest)
            .catch(err => {
              console.log('err in sendEmailResult', err);
              notify(err.message, 3000);
            });
          const smsModalCloseButton = document.getElementById('smsModalCloseButton');
          setsendEmailEnabled(false);
          // console.log('sendEmailResult', sendEmailResult);
          if (sendEmailResult.status === 200 && sendEmailResult.data.message === "Your Boarding Pass sent to respective email address.") {
            // await updateAddress();
            document.getElementById("showAndHideSpinner").style.display = "none";
            notifySuccess('Successfully sent email to the passenger(s).', 3000);
            smsModalCloseButton.click();
          } else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            notify('Something went wrong. Please try again after sometime.', 3000);
            smsModalCloseButton.click();
          }
        } else {
          notify('Valid email id is not provided for selected passenger(s)');
        }
      }

      if (sendSMSEnabled || sendWhatsappEnabled) {
        let passengersToSendSms = passengersForSMSPush.length > 1
          ? (passengersForSMSPush.every(p => p.isChecked && p.phone !== '' && 10 <= p.phone.length && p.phone.length <= 12)
            ? passengersForSMSPush.filter(p => p.isChecked && p.phone !== '' && 10 <= p.phone.length && p.phone.length <= 12) : [])
          : passengersForSMSPush.filter(p => p.phone !== '' && 10 <= p.phone.length && p.phone.length <= 12);
        if (passengersForSMSPush.length === 1) {
          passengersToSendSms = passengersForSMSPush.filter(p => p.phone !== '' && 10 <= p.phone.length && p.phone.length <= 12);
        } else if (passengersForSMSPush.length && passengersForSMSPush.length > 1) {
          passengersToSendSms = passengersForSMSPush.filter(p => p.isChecked && p.phone !== '' && 10 <= p.phone.length && p.phone.length <= 12);
          if (passengersToSendSms.length !== passengersForSMSPush.length && (passengersForSMSPush.filter(p => p.isChecked && p.phone === '').length)) {
            notify('Valid phone number is not provided for selected passenger(s)');
            return;
          }
        }
        let segmentInfo = [];
        let departureStation = '';
        let arrivalStation = '';
        const sendSmsRequest = {
          pnr: SearchedFlightDetails.recordLocator,
          paxdetailsforBP: []
        }
        SearchedFlightDetails.journeys.forEach(j => {
          j.segments.filter(seg => seg.IsSelected).forEach(s => {
            const arrival = s.designator.arrival;
            const str = arrival.substring(0, arrival.indexOf('T'));
            // console.log(str.replaceAll(/-/gi, ''));
            const segmentInfoString = `${str.replaceAll(/-/gi, '')}${s.designator.origin}${s.designator.destination}`;
            departureStation = s.designator.origin;
            arrivalStation = s.designator.destination;
            const departureDate = moment(s.designator.departure).format("YYYY-MM-DD");
            segmentInfo.push(segmentInfoString);
            passengersToSendSms.forEach(ps => {
              sendSmsRequest.paxdetailsforBP.push({
                passengerName: `${ps.name.title} ${ps.name.first} ${ps.name.last}`,
                //segmentinfo: segmentInfo,
                phoneNo: ps.phone,
                arrivalStation,
                departureStation,
                departureDate,
                paxKey: ps.passengerKey
              })
            })
          });
        });
        if (sendSMSEnabled) {
          const sendSmsResult = await fncSendSMS(sendSmsRequest)
            .catch(err => {
              console.log('err in sendSmsResult', err);
              notify(err.message, 3000);
            });
          // console.log('sendSmsResult', sendSmsResult.status, sendSmsResult.data.message);
          const smsModalCloseButton = document.getElementById('smsModalCloseButton');
          setsendSMSEnabled(false);
          if (sendSmsResult.status === 200 && sendSmsResult.data.message === "SMS has been sent successfully") {
            // await updateAddress();
            document.getElementById("showAndHideSpinner").style.display = "none";
            notifySuccess('Successfully sent sms to the passenger(s).', 3000);
            smsModalCloseButton.click();
          } else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            notify('Something went wrong in sending Sms. Please try again after sometime.', 3000);
            smsModalCloseButton.click();
          }
        }

        if (sendWhatsappEnabled) {
          const sendWhatsappResult = await fncSendWhatsapp(sendSmsRequest)
            .catch(err => {
              console.log('err in sendWhatsappResult', err);
              notify(err.message, 3000);
            });
          const smsModalCloseButton = document.getElementById('smsModalCloseButton');
          setsendWhatsappEnabled(false);
          // console.log('sendWhatsappResult', sendWhatsappResult.status, sendWhatsappResult.data.message)
          if (sendWhatsappResult.status === 200 && sendWhatsappResult.data.message === "Message has been sent successfully") {
            // await updateAddress();
            document.getElementById("showAndHideSpinner").style.display = "none";
            notifySuccess('Successfully sent whatsapp to the passenger(s).', 3000);
            smsModalCloseButton.click();

          } else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            notify('Something went wrong in sending Whatsapp. Please try again after sometime.', 3000);
            smsModalCloseButton.click();
          }
        }
      }
      // else {
      //   notify('Valid phone number is not provided for selected passenger(s)');
      // }
    }
  }

  const updateAddress = async () => {
    const passengerToAdd = passengersForSMSPush.length > 1 ? passengersForSMSPush.filter(p => p.isChecked && p.passengerAddressKey === undefined) : passengersForSMSPush.filter(p => p.passengerAddressKey === undefined);
    const passengerToUpdate = passengersForSMSPush.length > 1 ? passengersForSMSPush.filter(p => p.isChecked && p.passengerAddressKey) : passengersForSMSPush.filter(p => p.passengerAddressKey);

    // const indianMobileRegex = /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
    let isValidRequest = true;
    let addPassengerRequest = [];
    let updatePassengerRequest = [];
    // debugger
    if (sendSMSEnabled || sendWhatsappEnabled) {
      if (passengerToAdd.length && passengerToAdd.some(p => p.phone === '')) {
        notify(`Phone number is not added for selected passenger(s)`);
        return false;
      }
      if (passengerToUpdate.length && passengerToUpdate.some(p => p.phone === '')) {
        notify(`Phone number is not added for selected passenger(s)`);
        return false;
      }
    }

    if (sendEmailEnabled) {
      if (passengerToAdd.length && passengerToAdd.some(p => p.email === '')) {
        notify(`Email is not added for selected passenger(s)`);
        return false;
      }
      if (passengerToUpdate.length && passengerToUpdate.some(p => p.email === '')) {
        notify(`Email is not added for selected passenger(s)`);
        return false;
      }
    }
    passengerToAdd.length && passengerToAdd.forEach(p => {
      if (sendEmailEnabled && p.email !== '' && !isValidEmail(p.email)) {
        notify(`Email is not valid for ${p.name.title} ${p.name.first} ${p.name.last}`);
        isValidRequest = false;
        return false;
      }
      if ((sendSMSEnabled || sendWhatsappEnabled) && p.phone !== '' && !isValidIndianPhone(p.phone)) {
        notify(`Phone number is not valid for ${p.name.title} ${p.name.first} ${p.name.last}`);
        isValidRequest = false;
        return false;
      }
    });

    passengerToUpdate.length && passengerToUpdate.forEach(p => {
      if (sendEmailEnabled && p.email !== '' && !isValidEmail(p.email)) {
        notify(`Email is not valid for ${p.name.title} ${p.name.first} ${p.name.last}`);
        isValidRequest = false;
        return false;
      }
      if ((sendSMSEnabled || sendWhatsappEnabled) && p.phone !== '' && !isValidIndianPhone(p.phone)) {
        notify(`Phone number is not valid for ${p.name.title} ${p.name.first} ${p.name.last}`);
        isValidRequest = false;
        return false;
      }
    });

    addPassengerRequest = passengerToAdd.map(p => {
      return {
        passengerKey: p.passengerKey,
        PassengerAddressInfo:
        {
          phone: p.phone,
          stationCode: p.stCode,
          emailaddress: p.email
        }
      }
    });

    updatePassengerRequest = passengerToUpdate.map(p => {
      return {
        passengerKey: p.passengerKey,
        addressKey: p.passengerAddressKey,
        PassengerAddressInfo:
        {
          phone: p.phone,
          stationCode: p.stCode,
          emailaddress: p.email
        }
      }
    });

    // console.log('addPassengerRequest,updatePassengerRequest', addPassengerRequest, updatePassengerRequest);

    if (addPassengerRequest.length && isValidRequest) {
      const addPaxAddressResult = await fncAddPassengerContactDetails(addPassengerRequest)
        .catch(e => console.log('err in fncAddPassengerContactDetails', e));
      // console.log('addPaxAddress', addPaxAddressResult);
      if (addPaxAddressResult.status == "401" && addPaxAddressResult.data == "") {
        document.getElementById("showAndHideSpinner").style.display = "none";
        settriggerModal(true);
      } else {
        document.getElementById("showAndHideSpinner").style.display = "none";
        if (addPaxAddressResult.data.isError == false) {
          document.getElementById("showAndHideSpinner").style.display = "block";
          fncSaveChangesApi()
            .then((returnVal) => {
              if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                settriggerModal(true);
              }
              else {
                document.getElementById("showAndHideSpinner").style.display = "none";
                if (returnVal.data.isError == false) {


                  document.getElementById("showAndHideSpinner").style.display = "block";
                  fncGetBookingFromState()
                    .then((returnVal) => {
                      if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        settriggerModal(true);
                      }
                      else {

                        if (returnVal.data.isError == false) {
                          if (returnVal.data.flightDetails != null) {
                            var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails);
                          }
                          dispatch(searchCredential(
                            {
                              type: "",
                              SearchedRecordData: stSearchedRecordData,
                              SearchedFlightDetails: assignStateAgain
                            }
                          ));
                          // if (isphoneNumberPresent) {
                          //   setSubmitButton(true);
                          // } 
                          // setenableSms(false);
                          notifySuccess('Successfully updated the contact details', 2000);
                          // modalCloseButton.click();
                        }
                        else {
                          document.getElementById("showAndHideSpinner").style.display = "none";
                          if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            settriggerModal(true);
                          } else {
                            notify(returnVal.data.errorDetail.errorMessage);
                          }
                        }
                        document.getElementById("showAndHideSpinner").style.display = "none";
                      }

                    })
                    .catch(err => console.log("Axios err: ", err))

                }
                else {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                    settriggerModal(true);
                  } else {
                    notify(returnVal.data.errorDetail.errorMessage);
                  }
                }
              }

            })
            .catch(e => console.log('Axios e: ', e));
        } else {
          document.getElementById("showAndHideSpinner").style.display = "none";
          if (fncCheckIfTokenIsExpired(addPaxAddressResult.data.errorDetail)) {
            settriggerModal(true);
          } else {
            notify(addPaxAddressResult.data.errorDetail.errorMessage);
          }
        }
      }
    }
    if (updatePassengerRequest.length && isValidRequest) {
      const updatePaxAddressResult = await fncEditPassengerContactDetails(updatePassengerRequest)
        .catch(e => console.log('err in fncEditPassengerContactDetails', e));
      // console.log('addPaxAddress', updatePaxAddressResult);
      if (updatePaxAddressResult.status == "401" && updatePaxAddressResult.data == "") {
        document.getElementById("showAndHideSpinner").style.display = "none";
        settriggerModal(true);
      } else {
        document.getElementById("showAndHideSpinner").style.display = "none";
        if (updatePaxAddressResult.data.isError == false) {
          document.getElementById("showAndHideSpinner").style.display = "block";
          fncSaveChangesApi()
            .then((returnVal) => {
              if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                settriggerModal(true);
              }
              else {
                document.getElementById("showAndHideSpinner").style.display = "none";
                if (returnVal.data.isError == false) {


                  document.getElementById("showAndHideSpinner").style.display = "block";
                  fncGetBookingFromState()
                    .then((returnVal) => {
                      if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        settriggerModal(true);
                      }
                      else {

                        if (returnVal.data.isError == false) {
                          if (returnVal.data.flightDetails != null) {
                            var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails);
                          }
                          dispatch(searchCredential(
                            {
                              type: "",
                              SearchedRecordData: stSearchedRecordData,
                              SearchedFlightDetails: assignStateAgain
                            }
                          ));
                          // if (isphoneNumberPresent) {
                          //   setSubmitButton(true);
                          // }
                          notifySuccess('Successfully updated the contact details', 2000);
                          // setenableSms(false);
                          // modalCloseButton.click();
                        }
                        else {
                          document.getElementById("showAndHideSpinner").style.display = "none";
                          if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            settriggerModal(true);
                          } else {
                            notify(returnVal.data.errorDetail.errorMessage);
                          }
                        }
                        document.getElementById("showAndHideSpinner").style.display = "none";
                      }

                    })
                    .catch(err => console.log("Axios err: ", err))

                }
                else {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                    settriggerModal(true);
                  } else {
                    notify(returnVal.data.errorDetail.errorMessage);
                  }
                }
              }

            })
            .catch(e => console.log('Axios e: ', e));
        } else {
          document.getElementById("showAndHideSpinner").style.display = "none";
          if (fncCheckIfTokenIsExpired(updatePaxAddressResult.data.errorDetail)) {
            settriggerModal(true);
          } else {
            notify(updatePaxAddressResult.data.errorDetail.errorMessage);
          }
        }
      }
    }
  }

  useEffect(() => {
    // debugger;
    if (!fncCheckSearchedFlightDetailsEmpty(SearchedFlightDetails)) {
      const { passenger, journeys } = SearchedFlightDetails;
      let lastselectedSegment = '';
      journeys.forEach(j => {
        j.segments.filter(s => s.IsSelected).forEach(seg => {
          lastselectedSegment = seg.designator.destination;
        })
      })
      // console.log('lastselectedSegment', passenger, journeys);
      const passengersForSMS = [...passenger.filter(p => p.IsSelected)];
      if (passengersForSMS.length) {
        passengersForSMS.forEach((p, i, pArr) => {
          if (p.addresses.length > 0) {
            p.addresses.forEach(add => {
              if ((add.emailAddress || add.phone) && lastselectedSegment === add.stationCode) {
                if (pArr.length > 1) {
                  p.isChecked = true;
                }
                p.email = add.emailAddress ? add.emailAddress : '';
                let ph = add.phone ? add.phone : '';
                if (ph !== '') {
                  const i = ph.indexOf('+');
                  if (i !== -1) {
                    ph = ph.substring(0, i === 0 ? i : i - 1) + ph.substring(i === 0 ? i + 1 : i, ph.length);
                  }
                }
                p.phone = ph;
                p.passengerAddressKey = add.passengerAddressKey;
                p.stCode = add.stationCode ? add.stationCode : lastselectedSegment;
              }
              // else {
              //   if (pArr.length > 1) {
              //     p.isChecked = false;
              //   }
              //   p.email = '';
              //   p.phone = '';
              //   p.passengerAddressKey = add.passengerAddressKey;
              //   p.stCode = add.stationCode ? add.stationCode : lastselectedSegment;
              // }
            })
          } else {
            if (pArr.length > 1) {
              p.isChecked = true;
            }
            p.email = '';
            p.phone = '';
            p.stCode = lastselectedSegment;
          }
        })
        if (passengersForSMS.length > 1) {
          setSelectAllPaxForSMS(true);
        }
        setPassengersForSMSPush(passengersForSMS);
      }
    }

    // if (passengersForSMS.length === 1) {
    //   setSinglePaxForSms(true)
    // }


  }, [SearchedFlightDetails]);

  useEffect(() => {

    const passenger = SearchedFlightDetails.passenger.length ? SearchedFlightDetails.passenger.filter(pax => pax.IsSelected) : [];
    if (passenger.length) {
      const passengersForUncheck = [];
      for (let i = 0; i < passenger.length; i++) {
        if (passenger[i].IsSelected == true) {
          let journeys = SearchedFlightDetails.journeys;
          for (let j = 0; j < journeys.length; j++) {
            let Segment = journeys[j].segments;
            for (let k = 0; k < Segment.length; k++) {
              if (Segment[k].IsSelected == true) {
                let passSegment = Segment[k].passengerSegment;
                for (let l = 0; l < passSegment.length; l++) {
                  if (passSegment[l].passengerKey == passenger[i].passengerKey && passSegment[l].liftStatus.toUpperCase() === "CheckedIn".toUpperCase()) {
                    passengersForUncheck.push(passenger[i]);
                  }
                }
              }
            }
          }
        }
      }
      const passengerArray = passengersForUncheck.map((pax) => {
        return {
          "label": pax.name.first + " " + pax.name.last,
          "value": pax.name.first + " " + pax.name.last,
          "FirstName": pax.name.first,
          "LastName": pax.name.last,
          "passengerKey": pax.passengerKey
        }
      });

      setPassengersListToUncheck(passengerArray);
      if (passengerArray.length === 1) {
        setSelectedPassengerDropdown(passengerArray);
      }
    }
  }, [SearchedFlightDetails.passenger]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.altKey && e.key.toLowerCase() === 'c') {
        if (!IsModulAndLoginDivDisabled) {
          dispatch(moduleAndLoginDivDisabled({
            type: "MODULE_AND_LOGINDIV_DISABLED",
            IsModulAndLoginDivDisabled: true
          }));
          fncFocusElementDependsOnPathLocation(location.pathname, checkInPassengersOrSaveChangesRef.current);
        } else if (IsModulAndLoginDivDisabled) {
          const headingDiv = document.querySelector(".modulebtn");
          if (headingDiv) {
            headingDiv.focus();
            dispatch(moduleAndLoginDivDisabled({
              type: "MODULE_AND_LOGINDIV_DISABLED",
              IsModulAndLoginDivDisabled: false
            }));
          }
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [IsModulAndLoginDivDisabled])

  function fncPassengerChangeDropdown(e) {
    setSelectedPassengerDropdown(e);
  }

  const checkBTSelectAll = (data) => {
    let selectAllFlag = false;
    let totalBags = [];
    for (let i = 0; i < data.length; i++) {
      totalBags = totalBags.concat(...data[i].bags);
    }
    if (totalBags.every(bag => bag.IsSelected)) {
      selectAllFlag = true;
    }
    console.log('totalBags', totalBags);
    setSelectAllBagsToPrint(selectAllFlag)
  }

  function fnSelectAllBagsToPrint(e) {
    let checked = e.currentTarget.checked;
    let data = [...AddBags];
    const checkedBags = getCheckedBaggageKeys(SearchedFlightDetails);
    for (let i = 0; i < data.length; i++) {
      let bags = data[i].bags;
      for (let j = 0; j < bags.length; j++) {
        if (checkedBags.includes(bags[j].baggageKey)) {
          bags[j].IsSelected = checked;
        }
      }
    }
    if (checked) {
      isBagTagPrintEnabled(false);
    }
    else {
      isBagTagPrintEnabled(true);
    }
    setAddBags(data);
    setSelectAllBagsToPrint(checked);
  }

  function fncSelectedBagTag(e, bagtag) {

    let checked = e.currentTarget.checked;
    let data = [...AddBags];
    let isSelectedCheckBox = true;
    for (let i = 0; i < data.length; i++) {
      let bags = data[i].bags;
      for (let j = 0; j < bags.length; j++) {
        if (bagtag == bags[j].osTag) {
          bags[j].IsSelected = checked;
        }
        if (bags[j].IsSelected) {
          isSelectedCheckBox = false;
        }
      }
    }

    checkBTSelectAll(data)

    if (!isSelectedCheckBox) {
      isBagTagPrintEnabled(false);
    }
    else {
      isBagTagPrintEnabled(true);
    }
    setAddBags(data);

  }

  const checkBPSelectAll = (data) => {
    // let data = [...BoardingPassDataForTransfer];
    debugger
    let selectAllFlag = false;
    let totalBPs = [];
    for (let i = 0; i < data.length; i++) {
      for (let k = 0; k < data[i].boardingPasses.length; k++) {
        totalBPs = totalBPs.concat(...data[i].boardingPasses[k].segments);
        // let segments = data[i].boardingPasses[k].segments;
      }
    }
    if (totalBPs.every(seg => seg.IsSelected)) {
      selectAllFlag = true;
    }
    setSelectAllBPToPrint(selectAllFlag);
  }

  function fnSelectAllBPToPrint(e) {
    let checked = e.currentTarget.checked;
    let data = [...BoardingPassDataForTransfer];
    for (let i = 0; i < data.length; i++) {
      for (let k = 0; k < data[i].boardingPasses.length; k++) {
        let segments = data[i].boardingPasses[k].segments;

        for (let j = 0; j < segments.length; j++) {
          segments[j].IsSelected = checked;
        }
      }
    }

    if (checked) {
      isBoardingPassPrintEnabled(false);
    }
    else {
      isBoardingPassPrintEnabled(true);
    }
    setBoardingPassDataForTransfer(data);
    setSelectAllBPToPrint(checked);
  }

  function fncSelectedBoardingPasses(e, barCode) {
    if (barCode != null) {
      let checked = e.currentTarget.checked;
      let isSelectedCheckBox = true;
      let data = [...BoardingPassDataForTransfer];
      for (let i = 0; i < data.length; i++) {
        for (let k = 0; k < data[i].boardingPasses.length; k++) {
          let segments = data[i].boardingPasses[k].segments;
          let barCodePassenger = data[i].boardingPasses[k].passenger.barCode.replace(/ /g, '')
          for (let j = 0; j < segments.length; j++) {
            if (barCodePassenger == barCode) {
              segments[j].IsSelected = checked;
            }
            if (segments[j].IsSelected == true) {
              isSelectedCheckBox = false;
            }
          }
        }
      }

      checkBPSelectAll(data)

      if (isSelectedCheckBox == false) {
        isBoardingPassPrintEnabled(false);
      }
      else {
        isBoardingPassPrintEnabled(true);
      }
      setBoardingPassDataForTransfer(data);
    }

  }


  function fncPassPrintBagTag(From, stateData) {

    if (From != "NOPOPUP" && From != "FROMCHECKIN" && From != "GOTOBAGTAG") {
      document.getElementById("btnCloseButton").click();
    }
    else {
      let data = [...AddBags];
      let SearchedFlightDetailsData = SearchedFlightDetails;
      if (From == "GOTOBAGTAG") {
        SearchedFlightDetailsData = stateData;
      }

      for (let a = 0; a < data.length; a++) {
        for (let i = 0; i < SearchedFlightDetailsData.journeys.length; i++) {
          let segment = SearchedFlightDetailsData.journeys[i].segments;
          for (let j = 0; j < segment.length; j++) {
            if (segment[j].IsSelected == true) {
              let passSeg = segment[j].passengerSegment
              for (let k = 0; k < passSeg.length; k++) {
                if (passSeg[k].passengerKey == data[a].passengerKey && passSeg[k].IsSelected == true) {
                  let bags = passSeg[k].bags;
                  for (let l = 0; l < bags.length; l++) {

                    let bags1 = data[a].bags;
                    for (let b = 0; b < bags1.length; b++) {

                      if ((bags1[b].baggageKey == bags[l].baggageKey) && "CHECKED" == bags[l].status.toUpperCase()) {
                        bags1[b].IsSelected = true;
                      }

                    }
                  }
                }
              }
            }
          }
        }
      }

      const bagData = data.filter(pax => pax.IsSelected && pax.bags.some(bag => bag.IsSelected));

      // document.getElementById('sideBar').style.display = 'none';
      // document.getElementById('HeaderID').style.display = 'none';
      // document.getElementById('SubHeaderID').style.display = 'none';
      // document.getElementById('IDSideBar').style.display = 'none';
      // document.getElementById('IDMainBody').style.maxWidth = "100%";
      // document.getElementById('IDMainBody').style.flex = "auto";
      if (bagData.length) {
        setAddBags(bagData);
        if(selectedMode == "Native"){
          setBPVisibility("BT");
        }
      }
    }
  }

  function fncIsPassengerCheckedIn(passengerKey) {
    for (let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
      let segments = SearchedFlightDetails.journeys[i].segments;
      for (let j = 0; j < segments.length; j++) {
        if (segments[j].IsSelected) {
          let passengerSegment = segments[j].passengerSegment
          for (let k = 0; k < passengerSegment.length; k++) {
            if (passengerSegment[k].passengerKey == passengerKey && passengerSegment[k].IsSelected == true) {
              return passengerSegment[k].liftStatus
            }
          }
        }
      }
    }
  }
  function fncCommitBaggage() {
    const localStoragePrinters = localStorage.getItem('Printers');
    if (selectedMode == "Native" && localStoragePrinters === null) {
      notify('Cannot provide bag tag print functionality as you have not selected printer(s).')
    } else if (selectedMode == "Native" && JSON.parse(localStoragePrinters).bagTag === null) {
      notify('Cannot provide bag tag print functionality as you have not selected printer(s).')
    } else {
      let passengerKeyArray = [];
      let journeyKey = "";
      let isPassengerCheckedIn = false;
      let isBagsAreInAddedState = false;

      let setIsSelected1 = SearchedFlightDetails.passenger;
      for (let i = 0; i < setIsSelected1.length; i++) {
        if (setIsSelected1[i].IsSelected) {
          for (let j = 0; j < setIsSelected1[i].bags.length; j++) {
            let status = fncBagStatus(SearchedFlightDetails, setIsSelected1[i].bags[j].baggageKey, setIsSelected1[i].passengerKey, "")
            if (status.toUpperCase() == "CHECKED") {
              isBagsAreInAddedState = true;
              let passengerStatus = fncIsPassengerCheckedIn(setIsSelected1[i].passengerKey);
              if (passengerStatus == "CheckedIn") {
                passengerKeyArray.push(setIsSelected1[i].passengerKey);
                isPassengerCheckedIn = true;
              }
            }
          }
        }
      }

      if (isBagsAreInAddedState == false) {
        notify("Bags are not added for the selected journey.");
        return false;
      }
      if (isPassengerCheckedIn == false) {
        notify("Kindly passenger checked in for the selected journey.")
        return false;
      }


      for (let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
        let segments = SearchedFlightDetails.journeys[i].segments;
        for (let j = 0; j < segments.length; j++) {
          if (segments[j].IsSelected) {
            journeyKey = SearchedFlightDetails.journeys[i].journeyKey;
          }
        }
      }


      // debugger; 
      let uniquepassengerKeyArray = passengerKeyArray.filter((item, i, ar) => ar.indexOf(item) === i);
      let data = [];
      for (let i = 0; i < uniquepassengerKeyArray.length; i++) {
        data.push({
          "journeyKey": journeyKey,
          "passengerKey": uniquepassengerKeyArray[i],
          "recordLocator": SearchedFlightDetails.recordLocator
        })
      }

      fncSaveChangesApi()
        .then((returnVal) => {
          if (returnVal.status == "401" && returnVal.data == "") {
            document.getElementById("showAndHideSpinner").style.display = "none";
            settriggerModal(true);
          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (returnVal.data.isError == false) {

              document.getElementById("showAndHideSpinner").style.display = "block";
              // fncSaveChanges("FROMCOMMITBAGGAGE");
              fncCheckInBaggages("FROMCOMMITBAGGAGE");

            }
            else {
              document.getElementById("showAndHideSpinner").style.display = "none";
              if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                settriggerModal(true);
              } else {
                notify(returnVal.data.errorDetail.errorMessage);
              }
            }
          }

        })
        .catch(err => console.log("Axios err: ", err))
    }
  }

  function fncReprintBagTag(FROM, assignStateAgain) {
    // debugger;
    const localStoragePrinters = localStorage.getItem('Printers');
    if (selectedMode == "Native" && localStoragePrinters === null) {
      notify('Cannot provide bag tag print functionality as you have not selected printer(s).')
    } else if (selectedMode == "Native" && JSON.parse(localStoragePrinters).bagTag === null) {
      notify('Cannot provide bag tag print functionality as you have not selected printer(s).')
    } else {
      if (FROM == "MODALOPEN") {
        document.getElementById("modalCloseReprintBag").click();
      }
      else {
        let data = [];
        for (let a = 0; a < AddBags.length; a++) {
          const obj = AddBags[a];
          for (let i = 0; i < assignStateAgain.journeys.length; i++) {
            let segment = assignStateAgain.journeys[i].segments;
            for (let j = 0; j < segment.length; j++) {
              if (segment[j].IsSelected == true) {
                let passSeg = segment[j].passengerSegment
                for (let k = 0; k < passSeg.length; k++) {
                  if (passSeg[k].passengerKey == AddBags[a].passengerKey && passSeg[k].IsSelected == true) {

                    let checkedBags = [];
                    let bags = passSeg[k].bags;
                    for (let l = 0; l < bags.length; l++) {

                      let bags1 = AddBags[a].bags;
                      for (let b = 0; b < bags1.length; b++) {

                        if ((bags1[b].baggageKey == bags[l].baggageKey) && "CHECKED" == bags[l].status.toUpperCase()) {
                          bags1[b].IsSelected = true;
                        }

                      }
                      checkedBags = bags1.filter(bg => bg.IsSelected);
                    }
                    obj.bags = checkedBags;

                  }
                }
              }
            }
          }
          data.push(obj);
        }
        // document.getElementById('sideBar').style.display = 'none';
        // document.getElementById('HeaderID').style.display = 'none';
        // document.getElementById('SubHeaderID').style.display = 'none';
        // document.getElementById('IDSideBar').style.display = 'none';
        // document.getElementById('IDMainBody').style.maxWidth = "100%";
        // document.getElementById('IDMainBody').style.flex = "auto";

        const bagData = data.filter(pax => pax.IsSelected && pax.bags.some(bag => bag.IsSelected));
        if (bagData.length) {
          let updatedAddBags = bagData;
          if (FROM === 'FROMCOMMITBAGGAGE' && initialBagCount.length) {
            // Execute the comparison and removal
            console.log('Processing bag removal...');
            updatedAddBags = removeSimilarBags(bagData, initialBagCount);
          }
          setAddBags(updatedAddBags);
          setPrintBagTagFrom(FROM);
          if(selectedMode == "Native"){
            setBPVisibility("BT");            
          }
          // setBgTagPrint(true);
        }
      }
    }
  }


  function fncGoForBagTagPrinting(from, androidTest) {
    document.getElementById("modalCloseReprintBag").click();
    let data = [];
    if (from == "PRINT") {
      data = [...AddBags];
      // let element = document.getElementsByClassName("fade modal-backdrop show");
      // element[0].classList.remove("fade", "modal-backdrop", "show");
      // document.getElementById("BagTagPopup").style.display = 'none';
      // document.getElementById('sideBar').style.display = 'none';
      // document.getElementById('HeaderID').style.display = 'none';
      // document.getElementById('SubHeaderID').style.display = 'none';
      // document.getElementById('IDSideBar').style.display = 'none';
      // document.getElementById('IDMainBody').style.maxWidth = "100%";
      // document.getElementById('IDMainBody').style.flex = "auto";
    }
    else {
      const checkedBags = getCheckedBaggageKeys(SearchedFlightDetails);
      data = [...AddBags];
      for (let i = 0; i < data.length; i++) {
        let bags = data[i].bags;
        for (let j = 0; j < bags.length; j++) {
          if (checkedBags.includes(bags[j].baggageKey)) {
            bags[j].IsSelected = true;
          }
        }
      }
    }

    // document.getElementById("BagTagPopup").style.display = 'none';
    // document.getElementById('sideBar').style.display = 'none';
    // document.getElementById('HeaderID').style.display = 'none';
    // document.getElementById('SubHeaderID').style.display = 'none';
    // document.getElementById('IDSideBar').style.display = 'none';
    // document.getElementById('IDMainBody').style.maxWidth = "100%";
    // document.getElementById('IDMainBody').style.flex = "auto";
    const bagData = data.filter(pax => pax.IsSelected && pax.bags.some(bag => bag.IsSelected));
    if (bagData.length) {
      if (androidTest === 'androidTest') {
        if(selectedMode == "Native"){
          setBgTagPrint(true);  
        }          
      }
      setPrintBagTagFrom(from);
      setAddBags(bagData);
      if(selectedMode == "Native"){
        setBPVisibility("BT");
      }
    }
  }
  function fncPrintBagTags(from, androidPrint = '') {
    fncGoForBagTagPrinting(from, androidPrint)
  }

  const fncPrintButtonClick = (from, withoutstatedata, bpPrint = false) => {

    let data = [];

    if (from === "PRINT") {
      document.getElementById("modalCloseReprintBoardingPass").click();
      data = [...BoardingPassDataForTransfer];
      // let element = document.getElementsByClassName("fade modal-backdrop show");
      // if (element && element.length) {
      //   element[0].classList.remove("fade", "modal-backdrop", "show");
      // }

      // document.getElementById("BoardingPassPopup").style.display = 'none';
      // document.getElementById('sideBar').style.display = 'none';
      // document.getElementById('HeaderID').style.display = 'none';
      // document.getElementById('SubHeaderID').style.display = 'none';
      // document.getElementById('IDSideBar').style.display = 'none';
      // document.getElementById('IDMainBody').style.maxWidth = "100%";
      // document.getElementById('IDMainBody').style.flex = "auto";
    }
    else {

      // data = [...BoardingPassDataForTransfer];
      // if (data == "") {
      //   data = withoutstatedata;
      // }
      data = withoutstatedata;
      if (data === "") {
        data = [...BoardingPassDataForTransfer];
      }
      for (let i = 0; i < data.length; i++) {
        for (let k = 0; k < data[i].boardingPasses.length; k++) {
          let segments = data[i].boardingPasses[k].segments;
          for (let j = 0; j < segments.length; j++) {
            segments[j].IsSelected = true;;
          }
        }

      }

      // document.getElementById('sideBar').style.display = 'none';
      // document.getElementById('HeaderID').style.display = 'none';
      // document.getElementById('SubHeaderID').style.display = 'none';
      // document.getElementById('IDSideBar').style.display = 'none';
      // document.getElementById('IDMainBody').style.maxWidth = "100%";
      // document.getElementById('IDMainBody').style.flex = "auto";
    }

    setBoardingPassDataForTransfer(data);
    setPrintingBoardingPassFrom(from);
    if(selectedMode == "Native"){

      if (bpPrint) {
        setBpPrint(true);
      }
      setBPVisibility("BP");
    }

    // setBPVisibility("BP");

  };

  const fncShowAndHideBP = (From) => {
    const localStoragePrinters = localStorage.getItem('Printers');
    debugger
    if (selectedMode == "Native" && localStoragePrinters === null && From !== 'NOPOPUP') {
      notify('Cannot provide print functionality as you have not selected printer(s).')
    } else {
      if (From != "NOPOPUP" && From != "FROMCHECKIN") {
        document.getElementById("modalCloseReprintBoardingPass").click();
      }
      else {
        // document.getElementById("showAndHideSpinner").style.display="block";
        ////---- ----------------------------------------- new implementation on 30 june --------------------------------
        let passengerLIST = [];
        let journeyKey = "";
        let segmentKeyArr = [];
        if (['FROMCHECKIN'].includes(From)) {
          for (let i = 0; i < SearchedFlightDetails.passenger.length; i++) {
            if (SearchedFlightDetails.passenger[i].IsSelected == true) {
              passengerLIST.push(
                // "passengerKey": SearchedFlightDetails.passenger[i].passengerKey
                SearchedFlightDetails.passenger[i].passengerKey
              )
            }
          }
        } else {
          for (let i = 0; i < SearchedFlightDetails.passenger.length; i++) {
            if (SearchedFlightDetails.passenger[i].IsSelected == true) {
              let journeys = SearchedFlightDetails.journeys;
              for (let j = 0; j < journeys.length; j++) {
                let Segment = journeys[j].segments;
                for (let k = 0; k < Segment.length; k++) {
                  if (Segment[k].IsSelected == true) {
                    let passSegment = Segment[k].passengerSegment;
                    for (let l = 0; l < passSegment.length; l++) {
                      if (passSegment[l].passengerKey == SearchedFlightDetails.passenger[i].passengerKey && passSegment[l].liftStatus.toUpperCase() === "CheckedIn".toUpperCase()) {
                        // passengerLIST.push(SearchedFlightDetails.passenger[i].passengerKey);
                        if (passengerLIST.length === 0 || (passengerLIST.length && !passengerLIST.includes(SearchedFlightDetails.passenger[i].passengerKey))) {
                          passengerLIST.push(SearchedFlightDetails.passenger[i].passengerKey);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        let count = 0;
        for (let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
          for (let j = 0; j < SearchedFlightDetails.journeys[i].segments.length; j++) {
            if (SearchedFlightDetails.journeys[i].segments[j].IsSelected == true) {
              segmentKeyArr[count] = SearchedFlightDetails.journeys[i].segments[j].segmentKey
              journeyKey = SearchedFlightDetails.journeys[i].journeyKey;
              count = count + 1;
            }
          }
        }
        let journeylength = 0;
        for (let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
          if (journeyKey == SearchedFlightDetails.journeys[i].journeyKey) {
            journeylength = SearchedFlightDetails.journeys.length;
          }
        }
        let boardingPassData = [];
        if (passengerLIST.length) {
          if (journeylength == segmentKeyArr.length) {
            boardingPassData.push({
              "RecordLocator": SearchedFlightDetails.recordLocator,
              "departureDate": getDepartureDate(segmentKeyArr[0]),
              "segmentKey": "",
              "journeyKey": journeyKey,
              "boardingPassPassengerFilterRequest": {
                "passengerKeys": passengerLIST,
                "source": "O"
              }
            })
          }
          else {
            for (let i = 0; i < segmentKeyArr.length; i++) {
              boardingPassData.push({
                "RecordLocator": SearchedFlightDetails.recordLocator,
                "departureDate": getDepartureDate(segmentKeyArr[i]),
                "segmentKey": segmentKeyArr[i],
                "journeyKey": "",
                "boardingPassPassengerFilterRequest": {
                  "passengerKeys": passengerLIST,
                  "source": "O"
                }
              })
            }
          }
          fncGetBoardingPassApi(boardingPassData)
            .then((returnVal) => {
              if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                settriggerModal(true);
              }
              else {
                document.getElementById("showAndHideSpinner").style.display = "none";
                if (returnVal.data.isError == false) {
                  let data = returnVal.data.boardingPassResponses;
                  for (let i = 0; i < data.length; i++) {
                    for (let k = 0; k < data[i].boardingPasses.length; k++) {
                      let segments = data[i].boardingPasses[k].segments;
                      for (let j = 0; j < segments.length; j++) {
                        segments[j].IsSelected = false;;
                      }
                    }
                  }
                  setBoardingPassDataForTransfer(data);
                  if (From == "FROMCHECKIN") {
                    if(selectedMode == "Native"){
                      fncPrintButtonClick("FROMCHECKIN", data);
                    }     
                    else if (selectedMode === 'SITA FLEX') {
                      fncPrintSitaBothBPandBT(data);
                    }               
                  }
                }
                else {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                    settriggerModal(true);
                  } else {
                    notify(returnVal.data.errorDetail.errorMessage);
                  }
                }
              }

            })
            .catch(err => console.log("Axios err: ", err))
        }
      }
    }
  };

  const getDepartureDate = (segKey) => {
    const { journeys } = SearchedFlightDetails;
    for (let i = 0; i < journeys.length; i++) {
      for (let j = 0; j < journeys[i].segments.length; j++) {
        if (journeys[i].segments[j].segmentKey === segKey) {
          return journeys[i].segments[j].designator.departure;
        }
      }
    }
  }

  const fncEnableDisable = (flag) => {
    // debugger
    let isContainBags = false;
    let isContainsAddedBags = false;
    let setIsSelected1 = SearchedFlightDetails.passenger;
    for (let i = 0; i < setIsSelected1.length; i++) {
      if (setIsSelected1[i].IsSelected) {
        for (let j = 0; j < setIsSelected1[i].bags.length; j++) {
          let status = fncBagStatus(SearchedFlightDetails, setIsSelected1[i].bags[j].baggageKey, setIsSelected1[i].passengerKey, "")
          if (status.toUpperCase() == "CHECKED") {
            isContainBags = true;
          }
          //  else if(status.toUpperCase()=="ADDED"){
          //   isContainsAddedBags=true;
          //  }  
          if (isBagAddedInState > 0) {
            isContainsAddedBags = true;
          }
        }
      }
    }

    const checkedBaggageKeys = getCheckedBaggageKeys(SearchedFlightDetails);
    let setIsSelected = SearchedFlightDetails.passenger;
    for (let i = 0; i < setIsSelected.length; i++) {
      let bags = setIsSelected[i].bags;
      for (let j = 0; j < bags.length; j++) {
        if (checkedBaggageKeys.includes(bags[j].baggageKey)) {
          bags[j].IsSelected = false;
        }
      }
    }

    setAddBags(setIsSelected);

    let BalanceAmount = SearchedFlightDetails.breakdown.balanceDue; //parseInt(SearchedFlightDetails.breakdown.balanceDue);
    let IsCheckInAllowed = true;
    let isUnCheckInAllowed = true;
    let passenger = SearchedFlightDetails.passenger;
    for (let i = 0; i < passenger.length; i++) {
      if (passenger[i].IsSelected == true) {
        let journeys = SearchedFlightDetails.journeys;
        for (let j = 0; j < journeys.length; j++) {
          let Segment = journeys[j].segments;
          for (let k = 0; k < Segment.length; k++) {
            if (Segment[k].IsSelected == true) {
              let passSegment = Segment[k].passengerSegment.filter(pseg => pseg.IsSelected);
              const selectedPassengers = passenger.filter(p => p.IsSelected);
              const pSegment = passSegment.filter(pseg => selectedPassengers.filter(sp => sp.passengerKey === pseg.passengerKey && sp.IsSelected && pseg.IsSelected));
              // const pSegment = passSegment.filter(pseg => pseg.IsSelected);
              const checkInAllowed = pSegment.every(pseg => pseg.seats.length > 0 && pseg.liftStatus.toUpperCase() === "Default".toUpperCase());
              if (isJumpSeatSelected || checkInAllowed) {
                IsCheckInAllowed = false;
              }
              if (pSegment.some(p => p.liftStatus.toUpperCase() === "CheckedIn".toUpperCase())) {
                isUnCheckInAllowed = false;
              }
            }
          }
        }
      }
    }

    if (isContainBags == true && BalanceAmount <= 0 && isUnCheckInAllowed == false && !isContainsAddedBags && flag !== 'REMOVEDBAGGAGES') {
      setCheckInBags(false);
    }
    else {
      setCheckInBags(true);
    }
    if (BalanceAmount <= 0 && IsCheckInAllowed == false) {
      setCheckInPassenger(false);
    } else {
      setCheckInPassenger(true);
    }
    const selectedPassengers = SearchedFlightDetails.passenger.filter(p => p.IsSelected);
    const havetd = selectedPassengers.every(item => item.traveldocuments.length);
    if (!isInternationalFlight(SearchedFlightDetails) && !docVerified) { //&& !havetd
      setCheckInPassenger(true);
    }
    if (flag !== 'REMOVEDBAGGAGES') { //isUnCheckInAllowed == false && 
      fncShowAndHideBP("NOPOPUP");
    }

    if (isContainsAddedBags == true && isUnCheckInAllowed == false && BalanceAmount <= 0) {
      setUnCheckInBags(false);
    }
    setUnCheckInAllowed(isUnCheckInAllowed)
    setUnCheckPassenger([
      {
        IsChecked: false,
        Id: "UNASSIGNSEAT",
        Name: 'Remove Seat(s)'
      },
      {
        IsChecked: false,
        Id: "REMOVEBAGS",
        Name: 'Remove baggage(s)'
      }
    ]);
  };

  useEffect(() => {
    fncEnableDisable();
  }, [SearchedFlightDetails, docVerified]);


  function fncIncreaseSegment(i) {
    segCount = segCount + 1;
    return segCount;
  }

  function checkinPassengerRequest() {
    // debugger
    const { recordLocator } = SearchedFlightDetails;
    const isInternational = isInternationalFlight(SearchedFlightDetails);
    const CheckInPassengers = SearchedFlightDetails.passenger.filter(pax => pax.IsSelected).map((pas) => {
      if (!isInternational) {
        return {
          "passengerKey": pas.passengerKey,
          "Title": pas.name.title,
          "FirstName": pas.name.first,
          "MiddleName": pas.name.middle,
          "LastName": pas.name.last,
          "verifiedTravelDocumentKeys": pas.traveldocuments.map(td => td.passengerTravelDocumentKey)
        }
      } else {
        return {
          "passengerKey": pas.passengerKey,
          "Title": pas.name.title,
          "FirstName": pas.name.first,
          "MiddleName": pas.name.middle,
          "LastName": pas.name.last
        }
      }
    });

    const requestBody = SearchedFlightDetails.journeys.map((journey) =>
      journey.segments.filter(seg => seg.IsSelected).map((segment) => {
        // console.log('isInternationalSeg(SearchedFlightDetails, segment.segmentKey)', isInternationalSeg(SearchedFlightDetails, segment.segmentKey));
        return ({
          RecordLocator: recordLocator,
          JourneyKey: journey.journeyKey,
          SegmentKey: segment.segmentKey,
          DepartureStation: segment.designator.origin,
          ArrivalStation: segment.designator.destination,
          FlightNumber: segment.identifier.identifier,
          FlightDepartureDate: segment.designator.departure,
          CheckInAgentID: UserName,
          CheckInPassengers,
          IsInternational: isInternationalSeg(SearchedFlightDetails, segment.segmentKey) //!isInternational
        })
      }
      )
    );
    return [].concat(...requestBody);
  }

  function fncCheckInUndoCheckInRequest() {
    // let sSearchedFlightDetails = SearchedFlightDetails;
    const isInternational = isInternationalFlight(SearchedFlightDetails);
    // const paxtoUncheck = SearchedFlightDetails.passenger.filter(pax => pax.IsSelected)

    let passengerLIST = selectedPassengerDropdown.map(pax => ({ passengerKey: pax.passengerKey }));
    if (!isInternational) {
      passengerLIST = selectedPassengerDropdown.map((pax) => {
        return {
          passengerKey: pax.passengerKey,
          verifiedReference: SearchedFlightDetails.passenger.find(p => p.passengerKey === pax.passengerKey).traveldocuments[0].passengerTravelDocumentKey
        }
      })
    }
    const Token = localStorage.getItem("LoginToken");
    let journeyKey = "";
    let segmentKeyArr = [];

    let count = 0;
    for (let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
      for (let j = 0; j < SearchedFlightDetails.journeys[i].segments.length; j++) {
        if (SearchedFlightDetails.journeys[i].segments[j].IsSelected == true) {
          segmentKeyArr[count] = SearchedFlightDetails.journeys[i].segments[j].segmentKey
          journeyKey = SearchedFlightDetails.journeys[i].journeyKey;
          count = count + 1;
        }
      }
    }

    let journeylength = 0;
    for (let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
      if (journeyKey == SearchedFlightDetails.journeys[i].journeyKey) {
        journeylength = SearchedFlightDetails.journeys[i].segments.length;
      }
    }
    let checkInPassengerDetails = [];
    if (journeylength == segmentKeyArr.length) {
      checkInPassengerDetails.push({
        "segmentKey": "",
        "journeyKey": journeyKey,
        "passengerKeys": passengerLIST,
        "recordLocator": SearchedFlightDetails.recordLocator
      })
    }
    else {
      for (let i = 0; i < segmentKeyArr.length; i++) {
        checkInPassengerDetails.push({
          "segmentKey": segmentKeyArr[i],
          "journeyKey": "",
          "passengerKeys": passengerLIST,
          "recordLocator": SearchedFlightDetails.recordLocator
        })
      }

    }
    return checkInPassengerDetails;
  }

  async function fncSearchApiCallForSeat(MES) {
    fncGetBookingFromState()
      .then((returnVal) => {
        if (returnVal.status == "401" && returnVal.data == "") {
          document.getElementById("showAndHideSpinner").style.display = "none";
          settriggerModal(true);
        }
        else {
          if (returnVal.data.isError == false) {

            if (returnVal.data.flightDetails != null) {
              var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "AUTOSEATASSIGN");
            }

            dispatch(searchCredential(
              {
                type: "",
                SearchedRecordData: stSearchedRecordData,
                SearchedFlightDetails: assignStateAgain
              }
            ));
            if (MES == "FROMCHECKIN") {
              fncShowAndHideBP("FROMCHECKIN");
            }
            if (MES === 'UNCHECK') {
              setCheckInPassenger(false);
              // setUnCheckInAllowed(true);
            }
            if (MES == "FROMUNCHECKIN") {
              setCheckInPassenger(false);
              setUnCheckInAllowed(true);
              fncUncheckPassenger("SEAT");
            }
            if (MES == "ALL") {
              setCheckInPassenger(false);
              setUnCheckInAllowed(true);
              fncUncheckPassenger("ALLSAVE");
            }
            if (MES == "BOOKINGCOMIT") {
              fncSaveChanges("BOOKINGCOMMIT");
            }
            if (MES == "ALLSAVE") {
              fncSaveChanges("ALLSAVE");
            }
            if (MES == "REMOVEBAGS") {
              fncRemoveBags();
            }
            if (MES == "WITHCHECKINBAGGAGE" || MES == "FORCHECKADDEDBAGS" || MES == "FOPUP") {
              fncCheckInBaggages(MES);
            }
            if (MES == "GOTOBAGTAG") {
              fncPassPrintBagTag("GOTOBAGTAG", assignStateAgain);
            }
            if (MES == "GOTOBAGTAGWITHPOPUPOPEN") {
              fncPassPrintBagTag("GOTOBAGTAGWITHPOPUPOPEN", "")
            }
            if (MES == "FROMSAVECHANGES") {
              document.getElementById("showAndHideSpinner").style.display = "none";
            } else {
              document.getElementById("showAndHideSpinner").style.display = "none";
            }

          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
              settriggerModal(true);
            } else {
              notify(returnVal.data.errorDetail.errorMessage);
            }
          }
          document.getElementById("showAndHideSpinner").style.display = "none";
        }

      })
      .catch(err => console.log("Axios err: ", err))
  }

  async function fncCheckInPassenger() {

    fncSaveChangesApi()
      .then((returnVal) => {
        if (returnVal.status == "401" && returnVal.data == "") {
          document.getElementById("showAndHideSpinner").style.display = "none";
          settriggerModal(true);
        }
        else {
          document.getElementById("showAndHideSpinner").style.display = "none";
          if (returnVal.data.isError == false) {


            document.getElementById("showAndHideSpinner").style.display = "block";
            let checkInPassengerDetails = checkinPassengerRequest(); 
            console.log('checkInPassengerDetails', checkInPassengerDetails);
            fncCheckInPassengerApi(checkInPassengerDetails)
              .then((returnVal) => {
                if (returnVal.status == "401" && returnVal.data == "") {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  settriggerModal(true);
                }
                else {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  if (returnVal.data.isError == false && returnVal.data.checkInResponses.length && returnVal.data.checkInResponses[0].isCheckInSuccess) {
                    fncSaveChanges("FROMCHECKIN");
                    // fncCheckInBaggages("FROMCHECKIN");
                  }
                  else {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                      settriggerModal(true);
                    } else {
                      notify(returnVal.data.errorDetail.errorMessage);
                    }
                  }
                }
              })
              .catch(err => console.log("Axios err: ", err))

          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
              settriggerModal(true);
            } else {
              notify(returnVal.data.errorDetail.errorMessage);
            }
          }
        }

      })
      .catch(err => console.log("Axios err: ", err))

  }


  function fncUncheckPassenger(MES) {
    //------------------------- undo check in api call ---------------------------------
    let vSearchedFlightDetails = SearchedFlightDetails.journeys;
    let UnassignSeats = [];

    for (let i = 0; i < vSearchedFlightDetails.length; i++) {
      let segments = vSearchedFlightDetails[i].segments;
      for (let j = 0; j < segments.length; j++) {
        if (segments[j].IsSelected == true) {
          let passSeg = segments[j].passengerSegment;
          // passSeg = passSeg.filter(p => p.passengerKey === selectedPassengerDropdown)
          for (let k = 0; k < passSeg.length; k++) {
            if (passSeg[k].IsSelected === true && passSeg[k].seats.length > 0 && selectedPassengerDropdown.filter(p => p.passengerKey === passSeg[k].passengerKey).length > 0) {
              UnassignSeats.push({
                "recordlocator": SearchedFlightDetails.recordLocator,
                "passengerKey": passSeg[k].passengerKey,
                "unitKey": passSeg[k].seats.length > 0 ? passSeg[k].seats[0].unitKey : "",
                "waiveFee": false,
                "ignoreSeatSsrs": true,
                "Mode": 'CheckedIn'
              })
            }
          }
        }
      }
    }

    fncUnAssignPassengerSeats(UnassignSeats)
      .then((returnVal) => {
        if (returnVal.status == "401" && returnVal.data == "") {
          document.getElementById("showAndHideSpinner").style.display = "none";
          settriggerModal(true);
        }
        else {
          if (returnVal.data.isError == false) {
            if (MES == "SEAT") {
              fncSearchApiCallForSeat("BOOKINGCOMIT");
            }
            else {
              fncSearchApiCallForSeat("ALLSAVE");
            }
          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
              settriggerModal(true);
            } else {
              notify(returnVal.data.errorDetail.errorMessage);
            }
          }
        }
      })
      .catch(err => console.log("Axios err: ", err))


    // ------------------------- undo check in api call ends here ---------------------------------

  }

  async function fncUndoCheckInApi(mes) {
    return new Promise((resolve, reject) => {
      const UndocheckInPassengerDetails = fncCheckInUndoCheckInRequest();
      fncUndoCheckInPassengerApi(UndocheckInPassengerDetails)
        .then((returnVal) => {
          if (returnVal.status == "401" && returnVal.data == "") {
            document.getElementById("showAndHideSpinner").style.display = "none";
            settriggerModal(true);
          }
          else {

            if (returnVal.data.isError == false) {

              if (mes === "ALL") {
                fncSearchApiCallForSeat("ALL");
              }
              else if (mes === "UNCHECK") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                fncSearchApiCallForSeat(mes);
                // fncEnableDisable();
              }
              else if (mes === 'REMOVEBAGS') {
                document.getElementById("showAndHideSpinner").style.display = "none";
                fncRemoveBags();
              }
              else {
                mes !== "UNCHECK" && fncSearchApiCallForSeat("FROMUNCHECKIN");
              }
              dispatch(docVerifyCredential(
                {
                  type: '',
                  documentsVerified: false
                }
              ))
              setPassengerUncheckDone(true);
            }
            else {
              document.getElementById("showAndHideSpinner").style.display = "none";
              if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                settriggerModal(true);
              } else {
                notify(returnVal.data.errorDetail.errorMessage);
              }
            }
          }

        })
        .catch(err => console.log("Axios err: ", err))

    })

  }
  async function fncUndoCheckInPassenger() {

    setModalShow(false);
    document.getElementById("showAndHideSpinner").style.display = "block";
    let SelectedUnCheckPassengerData = [...st_UnCheckPassenger];
    let isBagRemove = false;
    let isSeatRemove = false;
    let isBothRemove = 0;
    // debugger
    for (let i = 0; i < SelectedUnCheckPassengerData.length; i++) {
      if (SelectedUnCheckPassengerData[i].IsChecked && SelectedUnCheckPassengerData[i].Id === "UNASSIGNSEAT") {
        isSeatRemove = true;
        isBothRemove = isBothRemove + 1;
      }
      else if (SelectedUnCheckPassengerData[i].IsChecked && SelectedUnCheckPassengerData[i].Id === "REMOVEBAGS") {
        isBagRemove = true;
        isBothRemove = isBothRemove + 1;
      }
    }
    if (isBothRemove === SelectedUnCheckPassengerData.length) {
      let result = await fncUndoCheckInApi("ALL");

    }
    else if (isSeatRemove) {
      fncUndoCheckInApi("SEAT");
    }
    else if (isBagRemove) {
      await fncUndoCheckInApi("REMOVEBAGS");
      // await fncRemoveBags();

    } else {
      fncUndoCheckInApi("UNCHECK");
    }

  }

  async function fncRemoveBags() {

    let passengers = selectedPassengerDropdown; //  SearchedFlightDetails.passenger;

    let removeBaggages = [];
    for (let i = 0; i < passengers.length; i++) {
      // if (passengers[i].IsSelected == true) {
      let journeys = SearchedFlightDetails.journeys;
      for (let j = 0; j < journeys.length; j++) {
        let Segment = journeys[j].segments;
        for (let k = 0; k < Segment.length; k++) {
          if (Segment[k].IsSelected == true) {
            let passSegment = Segment[k].passengerSegment;
            for (let l = 0; l < passSegment.length; l++) {
              if (passSegment[l].passengerKey === passengers[i].passengerKey) {
                const bagsToRemove = passSegment[l].bags.filter(bag => bag.status === 'Checked');
                if (bagsToRemove.length) {
                  for (const item of bagsToRemove) {
                    removeBaggages.push({
                      "journeyKey": journeys[j].journeyKey,
                      "passengerKey": passengers[i].passengerKey,
                      "baggageKey": item.baggageKey
                    })

                  }
                }
              }
              // if (passSegment[l].passengerKey == passengers[i].passengerKey && passSegment[l].seats.length > 0 && passSegment[l].liftStatus.toUpperCase() === "Default".toUpperCase()) {
              //   IsCheckInAllowed = false;
              // }
            }
          }
        }
      }
      // }
    }
    await fncRemoveBaggageApi(removeBaggages);
  }

  const fncRemoveBaggageApi = async (removeBaggages) => {

    //  resolve(
    fncRemoveBaggage(removeBaggages)
      .then((returnVal) => {

        if (returnVal.status == "401" && returnVal.data == "") {
          document.getElementById("showAndHideSpinner").style.display = "none";
          settriggerModal(true);
        }
        else {
          if (returnVal.data.isError == false) {
            fncSaveChanges("BOOKINGCOMMIT");

          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
              settriggerModal(true);
            } else {
              notify(returnVal.data.errorDetail.errorMessage);
            }
          }
        }

      })
      .catch(err => console.log("Axios err: ", err))
    //  )
    //   })


  }

  function fncSaveChanges(MES) {

    document.getElementById("showAndHideSpinner").style.display = "block";
    fncSaveChangesApi()
      .then((returnVal) => {
        if (returnVal.status == "401" && returnVal.data == "") {
          // debugger;
          document.getElementById("showAndHideSpinner").style.display = "none";
          settriggerModal(true);
        }
        else {
          document.getElementById("showAndHideSpinner").style.display = "none";
          if (returnVal.data.isError == false) {
            if (MES == "ALLSAVE") {
              fncSearchApiCallForSeat("REMOVEBAGS");
            }
            else if (MES == "WITHCHECKINBAGGAGE" || MES == "FORCHECKADDEDBAGS" || MES == "FOPUP") {
              if (JSON.parse(localStorage.getItem("AddedBags")) != null) {
                fncSearchApiCallForSeat(MES);
              }

            }
            else if (MES == "FROMCHECKIN" || MES == "FROMCOMMITBAGGAGE") {
              fncCheckInBaggages(MES);
            }
            else {
              fncSearchApiCallForSeat("FROMSAVECHANGES");

            }
          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
              settriggerModal(true);
            } else {
              notify(returnVal.data.errorDetail.errorMessage);
            }
          }
        }

      })
      .catch(err => console.log("Axios err: ", err))

  }
  function onPrintFinish(param, obj) {
    // doClose()
    // debugger
    // alert('onPrintFinish', param)
    if (param == "BP") {
      const checkedBags = getCheckedBaggageKeys(SearchedFlightDetails);
      let data = [];
      data = [...AddBags];
      for (let i = 0; i < data.length; i++) {
        let bags = data[i].bags;
        for (let j = 0; j < bags.length; j++) {
          if (checkedBags.includes(bags[j].baggageKey)) {
            bags[j].IsSelected = true;
          }
        }
      }
      const bagData = data.filter(pax => pax.IsSelected && pax.bags.some(bag => bag.IsSelected));
      if (bagData.length === 0) {
        window.location.reload();
      }
      fncGoForBagTagPrinting("PRINTALL");
    }
    else {
      // obj.close();
      window.location.reload();
    }
  }

  /** effect for opening/closing side menu using shortcut keys (ALT + e)  */
  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
        handleSideMenu();
      }
    })
  });

  useEffect(() => {
    document.addEventListener("keydown", shortcutKeyHandler);

    return () => {
      document.removeEventListener('keydown', shortcutKeyHandler);
    };
  });
  const shortcutKeyHandler = (event) => {
    const tag = event.target.tagName.toLowerCase();
    const isTypingField = tag === 'input' || tag === 'textarea' || event.target.isContentEditable;
    if (shortcutKeysForPageNavigation.includes(event.key)) {
      const path = shortcutKeyForPage(location.pathname, event, SearchedFlightDetails);
      if (path) {
        history.push('/' + path);
      }
    }
    if (isTypingField && !event.ctrlKey) return;
    if (event.ctrlKey && shortcutKeys.includes(event.key)) {
      if (shortcutKeysforHumburgerMenu.includes(event.key)) {
        dispatch(redirectToPageCredentials(
          {
            type: "",
            redirectionPage: location.pathname
          }
        ));
      }
      const path = shortcutKeyForPage(location.pathname, event);
      if (path) {
        history.push('/' + path);
      }
    }
  }

  const handlePrints = async (children) => {
    const result = await Promise.all(
      children.map(async (child) => {
        const canvas = await html2canvas(document.getElementById(child), { scale: 5 })
        return canvas;

      })
    )
    return result;
  }

  useEffect(async () => {
    debugger
    const JSPM = window.JSPM;

    // console.log('availablePrinters', availablePrinters);
    const localStoragePrinters = localStorage.getItem('Printers');

    function findMatchingKey(devices, searchString) {
      for (const [key, values] of Object.entries(devices)) {
        if (values !== null && values.some(value => searchString.includes(value))) {
          return key;
        }
      }
      return 'No match found';
    }

    console.log('printer in local storage', localStoragePrinters);
    if (BPVisibility === "BP" || BPVisibility === "BT") {
      // if (availablePrinters.length === 0) {
      //   connectJSPM();
      // }
      if (BPVisibility === "BP") {
        debugger
        console.log('BoardingPassDataForTransfer BPVisibility === "BP"', BoardingPassDataForTransfer);
        // const divContents = document.getElementById("boardingPass").innerHTML;
        if (clientInfo.includes('Android')) {
          console.log('boarding pass to transfer in andorid', BoardingPassDataForTransfer)
          if (localStoragePrinters === null) {
            setBPVisibility(false);
            notify('Cannot provide boarding pass print functionality as you have not selected printer(s).')
          } else if (JSON.parse(localStoragePrinters).boardingPass === null) {
            notify('Cannot provide boarding pass print functionality as you have not selected printer(s).')
          } else {
            console.log('boarding pass to transfer in Android', BoardingPassDataForTransfer)
            const printers = JSON.parse(localStoragePrinters);

            const boardingpassPrinter = printers.boardingPass;
            // alert('boardingpassPrinter', boardingpassPrinter);
            if (boardingpassPrinter.address) {
              console.log('boarding pass to print using bluetooth Android', BoardingPassDataForTransfer)
              setBPVisibility(false);
              if (BoardingPassDataForTransfer.length > 0) {
                let zplCmndCount = 0;
                const zplCommandsArray = []
                BoardingPassDataForTransfer.forEach((item, i) => {
                  item.boardingPasses.forEach((bp, j) => {
                    bp.segments.length > 0 &&
                      bp.segments.forEach((seg, k) => {
                        if (seg.IsSelected) {

                          let zplCommandForBP = '';
                          zplCommandForBP = getZPLCommandForBoardingPass(SearchedFlightDetails, bp, item, seg);
                          zplCommandsArray.push(zplCommandForBP);
                        }
                      })
                  })
                })

                btCommBP.send(zplCommandsArray.join('\n'))
                if (printingBoardingPassFrom === "FROMCHECKIN") {
                  onPrintFinish("BP");
                } else {
                  onPrintFinish("");
                }
              }
            }
          }
        } else {
          if (localStoragePrinters === null) {
            setBPVisibility(false);
            notify('Cannot provide boarding pass print functionality as you have not selected printer(s).')
          } else if (JSON.parse(localStoragePrinters).boardingPass === null) {
            notify('Cannot provide boarding pass print functionality as you have not selected printer(s).')
          } else {
            console.log('boarding pass to transfer', BoardingPassDataForTransfer)
            const printers = JSON.parse(localStoragePrinters);

            const boardingpassPrinter = printers.boardingPass;
            if (boardingpassPrinter.address) {
              console.log('boarding pass to print using bluetooth', BoardingPassDataForTransfer)
              setBPVisibility(false);
              if (BoardingPassDataForTransfer.length > 0) {
                let zplCmndCount = 0;
                const zplCommandsArray = []
                BoardingPassDataForTransfer.forEach((item, i) => {
                  item.boardingPasses.forEach((bp, j) => {
                    bp.segments.length > 0 &&
                      bp.segments.forEach((seg, k) => {
                        if (seg.IsSelected) {

                          let zplCommandForBP = '';
                          zplCommandForBP = getZPLCommandForBoardingPass(SearchedFlightDetails, bp, item, seg);
                          zplCommandsArray.push(zplCommandForBP);
                        }
                      })
                  })
                })
                let cpj = new JSPM.ClientPrintJob();
                cpj.clientPrinter = new JSPM.BluetoothPrinter(boardingpassPrinter.address, 1);
                cpj.printerCommands = zplCommandsArray.join('\n');
                if (printingBoardingPassFrom === "FROMCHECKIN") {
                  onPrintFinish("BP");
                } else {
                  onPrintFinish("");
                }
                cpj.sendToClient();
                console.log('zplCmndCount==========', zplCmndCount);
              }
            } else {
              const result = findMatchingKey(printersConfigBP, boardingpassPrinter.name.toUpperCase());
              // console.log(result);  // Output: TSCPL
              console.log('finding print commands for printer', result, 'printersConfigBP', printersConfigBP);
              if (result === 'No match found') {
                notify('Cannot provide boarding pass print functionality as you have not selected printer(s).')
              }
              if (result.toUpperCase() === 'ZPL') {
                console.log('bp printing via usb for command', result);
                setBPVisibility(false);
                let zplCmndCount = 0;
                const zplcommandsArray = [];
                if (BoardingPassDataForTransfer.length > 0) {
                  BoardingPassDataForTransfer.forEach((item, i) => {
                    item.boardingPasses.forEach((bp, j) => {
                      bp.segments.length > 0 &&
                        bp.segments.forEach((seg, k) => {
                          if (seg.IsSelected) {
                            let zplCommandForBP = '';
                            zplCommandForBP = getZPLCommandForBoardingPass(SearchedFlightDetails, bp, item, seg);
                            zplcommandsArray.push(zplCommandForBP);
                          }
                        })
                    })
                  })
                  let cpj = new JSPM.ClientPrintJob();
                  cpj.clientPrinter = new JSPM.InstalledPrinter(boardingpassPrinter.name);
                  cpj.printerCommands = zplcommandsArray.join('\n');
                  cpj.onFinished = function (data) {
                    console.log(`onFinished event foor printing on ${boardingpassPrinter.name} `, data);
                    // if (data && data.result && data.result === 'ClientPrintJob done') {
                    if (printingBoardingPassFrom === "FROMCHECKIN") {
                      onPrintFinish("BP");
                    } else {
                      onPrintFinish("");
                    }
                    // }
                  };
                  cpj.sendToClient();
                  console.log('zplCmndCount in zpl usb', zplCmndCount);
                }
              }
              if (result.toUpperCase() === 'HTML') {
                console.log('bp printing via usb for html', boardingpassPrinter);
                /**----------------- jspm html implementation start------------------- */
                let parent = document.getElementById("boardingPass");
                let children = parent.querySelectorAll('.child');
                // var cpj = new JSPM.ClientPrintJob();
                const childs = [];
                for (let i = 0; i < children.length; i++) {
                  childs.push(children[i].id);
                }
                // const boardingpPrint = availablePrinters.filter(str => str.includes(` ${BPVisibility}`));

                console.log('boardingpPrint', boardingpassPrinter);
                setBPVisibility(false);
                const result = await handlePrints(childs);
                console.log('result', result)
                var cpj = new JSPM.ClientPrintJob();
                result.forEach((res, i) => {
                  var b64Prefix = "data:image/png;base64,";
                  var imgBase64DataUri = res.toDataURL("image/png");
                  var imgBase64Content = imgBase64DataUri.substring(b64Prefix.length, imgBase64DataUri.length);

                  var myImageFile = new JSPM.PrintFile(imgBase64Content, JSPM.FileSourceType.Base64, `myFileToPrint${i}.png`, 1);
                  //add file to print job
                  cpj.files.push(myImageFile);
                })
                cpj.clientPrinter = new JSPM.InstalledPrinter(boardingpassPrinter.name);
                //Send print job to printer!
                cpj.sendToClient();
                /** this code causing --> reprint boarding printing bag tag as well */
                if (printingBoardingPassFrom === "FROMCHECKIN") {
                  onPrintFinish("BP");
                } else {
                  onPrintFinish("");
                }
                /**----------------- jspm html implementation end-------------------- */
              }
              if (result.toUpperCase() === 'TSCPL') {
                console.log('bp print via usb in TSCPL');
                setBPVisibility(false);
                if (BoardingPassDataForTransfer.length > 0) {
                  const zplcommandsArray = [];
                  BoardingPassDataForTransfer.forEach((item, i) => {
                    item.boardingPasses.forEach((bp, j) => {
                      bp.segments.length > 0 &&
                        bp.segments.forEach((seg, k) => {
                          if (seg.IsSelected) {
                            let zplCommandForBP = '';
                            // TSCPL commands to be fetched here for boarding pass
                            zplCommandForBP = getZPLCommandForBoardingPass(SearchedFlightDetails, bp, item, seg);
                            zplcommandsArray.push(zplCommandForBP);
                          }
                        })
                    })
                  })
                  let cpj = new JSPM.ClientPrintJob();
                  cpj.clientPrinter = new JSPM.InstalledPrinter(boardingpassPrinter.name);
                  cpj.printerCommands = zplcommandsArray.join('\n');
                  cpj.onFinished = function (data) {
                    console.log(`onFinished event foor printing on ${boardingpassPrinter.name}`, data);
                    // if (data && data.result && data.result === 'ClientPrintJob done') {
                    if (printingBoardingPassFrom === "FROMCHECKIN") {
                      onPrintFinish("BP");
                    } else {
                      onPrintFinish("");
                    }
                  }
                  // };
                  cpj.sendToClient();
                }
              }

            }
          }
        }

        /**-------------window browser popup start --------------- */
        // let orientation = printerForBoardingPass['Custom'] ? 'portrait' : printerForBoardingPass['Tsc'] ? 'landscape'
        // : printerForBoardingPass['OnlyTSCStation'].includes(Location) ? 'landscape'
        // : 'portrait';

        // // console.log('divContents boardingPass', divContents);
        // if (!bpPrint) {
        //   let a = window.open();
        //   a.document.open('', '', 'height=1000, width=1000');
        //   a.document.write('<html><head>'+
        //   `<style> @page {size: ${orientation};margin:0;} </style></head>`);
        //   a.document.write(divContents);
        //   a.document.write('</html>');
        //   a.document.close();
        //   a.print();
        //   a.close();
        //   /** this code causing --> reprint boarding printing bag tag as well */
        //   if (printingBoardingPassFrom === "FROMCHECKIN") {
        //     onPrintFinish("BP");
        //   } else {
        //     onPrintFinish("", a);
        //   }
        // } else {
        //   const myWindow = window.open();
        //   myWindow.document.open('', '','height=1000, width=1000');
        //   myWindow.document.write('<html><head>'+
        //   `<style> @page {size: ${orientation};margin:0;{-webkit-print-color-adjust: exact;}} </style></head>`);
        //   myWindow.document.write(divContents);
        //   myWindow.document.write('</html>');
        //   myWindow.document.close();
        // }
        /**-------------window browser popup end --------------- */
      }
      else if (BPVisibility === "BT") {
        debugger
        console.log('availableBluetoothPrinters in bagtag printing', availableBluetoothPrinters, 'clientInfo', clientInfo);

        if (clientInfo.includes('Android')) {
          // alert('clientInfo.includes(Android)', clientInfo.includes('Android'));
          if (localStoragePrinters === null) {
            setBPVisibility(false);
            notify('Cannot provide bag tag print functionality as you have not selected printer(s).')
          } else if (JSON.parse(localStoragePrinters).bagTag === null) {
            notify('Cannot provide bag tag print functionality as you have not selected printer(s).')
          } else {
            const printers = JSON.parse(localStoragePrinters);
            const bagtagPrinter = printers.bagTag;
            // alert('bagtagPrinter', bagtagPrinter)
            if (bagtagPrinter.address) {
              const { BagsTagToPrint, a } = getBagtagPrintData(AddBags,
                SearchedFlightDetails.journeys.map(j => j.segments.filter(seg => seg.IsSelected)).filter(jarr => jarr.length),
                lrtBagType);
              console.log('BagsTagToPrint via bluetooth', BagsTagToPrint, a);
              setBPVisibility(false);

              if (BagsTagToPrint.length > 0) {
                const printerCommandsBT = [];
                BagsTagToPrint.forEach((item, i) => {
                  const selectedBags = item.bags.filter(items => items.IsSelected);
                  selectedBags.forEach((bt, j) => {
                    let zplCommand = '';
                    if (bt.table.length === 1) {
                      zplCommand = getTSCPLCommandForDirectBagTag(item, bt, j, SearchedFlightDetails.recordLocator, a);
                      // zplCommand = getZPLCommandForDirectBagTag(item,bt,j,SearchedFlightDetails.recordLocator, a);
                    } else if (bt.table.length > 1) {
                      zplCommand = getTSCPLCommandForConnectingBagTag(item, bt, j, SearchedFlightDetails.recordLocator, a);
                      // zplCommand = getZPLCommandForConnectingBagTag(item,bt,j,SearchedFlightDetails.recordLocator, a);
                    }
                    console.log('zplCommand', zplCommand)
                    printerCommandsBT.push(zplCommand);
                  })
                })
                btCommBT.send(printerCommandsBT.join('\n'))
                onPrintFinish("BT");
              }
            }
          }
        } else {
          if (localStoragePrinters === null) {
            setBPVisibility(false);
            notify('Cannot provide bag tag print functionality as you have not selected printer(s).')
          } else if (JSON.parse(localStoragePrinters).bagTag === null) {
            notify('Cannot provide bag tag print functionality as you have not selected printer(s).')
          } else {
            const printers = JSON.parse(localStoragePrinters);
            const bagtagPrinter = printers.bagTag;
            if (bagtagPrinter.address) {
              const { BagsTagToPrint, a } = getBagtagPrintData(AddBags,
                SearchedFlightDetails.journeys.map(j => j.segments.filter(seg => seg.IsSelected)).filter(jarr => jarr.length),
                lrtBagType);
              console.log('BagsTagToPrint via bluetooth', BagsTagToPrint, a);
              setBPVisibility(false);
              const printerCommandsBT = [];
              if (BagsTagToPrint.length > 0) {
                BagsTagToPrint.forEach((item, i) => {
                  const selectedBags = item.bags.filter(items => items.IsSelected);
                  selectedBags.forEach((bt, j) => {
                    let zplCommand = '';
                    if (bt.table.length === 1) {
                      zplCommand = getTSCPLCommandForDirectBagTag(item, bt, j, SearchedFlightDetails.recordLocator, a);
                      // zplCommand = getZPLCommandForDirectBagTag(item,bt,j,SearchedFlightDetails.recordLocator, a);
                    } else if (bt.table.length > 1) {
                      zplCommand = getTSCPLCommandForConnectingBagTag(item, bt, j, SearchedFlightDetails.recordLocator, a);
                      // zplCommand = getZPLCommandForConnectingBagTag(item,bt,j,SearchedFlightDetails.recordLocator, a);
                    }
                    console.log('zplCommand', zplCommand)
                    printerCommandsBT.push(zplCommand);
                  })
                })
                let cpjBluetooth = new JSPM.ClientPrintJob();
                cpjBluetooth.clientPrinter = new JSPM.BluetoothPrinter(bagtagPrinter.address, 1);
                cpjBluetooth.printerCommands = printerCommandsBT.join('\n');
                // if (data && data.result && data.result === 'ClientPrintJob done') {
                onPrintFinish("BT");
                // }
                cpjBluetooth.sendToClient();
              }
            } else {
              const result = findMatchingKey(printersConfigBT, bagtagPrinter.name.toUpperCase());
              // console.log(result);  // Output: TSCPL
              if (result === 'No match found') {
                notify('Cannot provide bag tag print functionality as you have not selected printer(s).')
              }
              console.log('finding print commands for printer', result, 'printersConfigBT', printersConfigBT);
              if (result.toUpperCase() === 'ZPL') {
                const { BagsTagToPrint, a } = getBagtagPrintData(AddBags,
                  SearchedFlightDetails.journeys.map(j => j.segments.filter(seg => seg.IsSelected)).filter(jarr => jarr.length),
                  lrtBagType);
                console.log('BagsTagToPrint in result.toUpperCase() === ZPL ', BagsTagToPrint, a);
                setBPVisibility(false);
                if (BagsTagToPrint.length > 0) {
                  const printerCommandsBT = [];
                  BagsTagToPrint.forEach((item, i) => {
                    const selectedBags = item.bags.filter(items => items.IsSelected);
                    selectedBags.forEach((bt, j) => {
                      let zplCommand = '';
                      if (bt.table.length === 1) {
                        zplCommand = getZPLCommandForDirectBagTag(item, bt, j, SearchedFlightDetails.recordLocator, a);
                        // zplCommand = getTSCPLCommandForDirectBagTag(item,bt,j,SearchedFlightDetails.recordLocator, a);
                      } else if (bt.table.length > 1) {
                        zplCommand = getZPLCommandForConnectingBagTag(item, bt, j, SearchedFlightDetails.recordLocator, a);
                      }
                      console.log('zplCommand', zplCommand)
                      printerCommandsBT.push(zplCommand);
                    })
                  })
                  let cpj = new JSPM.ClientPrintJob();
                  cpj.clientPrinter = new JSPM.InstalledPrinter(bagtagPrinter.name);
                  cpj.printerCommands = printerCommandsBT.join('\n');
                  cpj.onFinished = function (data) {
                    console.log(`onFinished event foor printing ${bagtagPrinter.name}`, data);
                    // if (data && data.result && data.result === 'ClientPrintJob done') {
                    onPrintFinish("BT");
                    // }
                  };
                  cpj.sendToClient();
                }
              }
              if (result.toUpperCase() === 'HTML') {
                console.log('BagsTagToPrint in result.toUpperCase() === html ');
                /**----------------- jspm html implementation start------------------- */
                let parent = document.getElementById('bagTag');
                let children = parent.querySelectorAll('.child');
                const childs = [];
                for (let i = 0; i < children.length; i++) {
                  childs.push(children[i].id);
                }
                // const btPrint = availablePrinters.filter(str => str.includes(BPVisibility));

                console.log('btPrint', bagtagPrinter);
                setBPVisibility(false);
                const result = await handlePrints(childs);
                console.log('result', result)
                result.forEach((res, i) => {
                  var cpj = new JSPM.ClientPrintJob();
                  cpj.clientPrinter = new JSPM.InstalledPrinter(bagtagPrinter.name);
                  var b64Prefix = "data:image/png;base64,";
                  var imgBase64DataUri = res.toDataURL("image/png");
                  var imgBase64Content = imgBase64DataUri.substring(b64Prefix.length, imgBase64DataUri.length);

                  var myImageFile = new JSPM.PrintFile(imgBase64Content, JSPM.FileSourceType.Base64, `myFileToPrint${i}.png`, 1);
                  // add file to print job
                  cpj.files.push(myImageFile);
                  cpj.onUpdated = function (data) {
                    console.log('onupdated event foor printing on ps-cbd1de ', data);
                    // if (data && data.result && data.result === 'ClientPrintJob done') {
                    //   onPrintFinish("BT");
                    // }
                  };

                  cpj.onFinished = function (data) {
                    console.log('onFinished event foor printing', data);
                    // if (data && data.result && data.result === 'ClientPrintJob done') {
                    onPrintFinish("BT");
                    // }
                  };
                  // Send print job to printer!
                  cpj.sendToClient();
                })
                // onPrintFinish("BT");
                /**----------------- jspm html implementation end-------------------- */
              }
              if (result.toUpperCase() === 'TSCPL') {
                const { BagsTagToPrint, a } = getBagtagPrintData(AddBags,
                  SearchedFlightDetails.journeys.map(j => j.segments.filter(seg => seg.IsSelected)).filter(jarr => jarr.length),
                  lrtBagType);
                console.log('BagsTagToPrint in result.toUpperCase() === TSCPL', BagsTagToPrint, a);
                setBPVisibility(false);
                if (BagsTagToPrint.length > 0) {
                  const printerCommandsBT = [];
                  BagsTagToPrint.forEach((item, i) => {
                    const selectedBags = item.bags.filter(items => items.IsSelected);
                    selectedBags.forEach((bt, j) => {
                      let zplCommand = '';
                      if (bt.table.length === 1) {
                        // zplCommand = getZPLCommandForDirectBagTag(item,bt,j,SearchedFlightDetails.recordLocator, a);
                        zplCommand = getTSCPLCommandForDirectBagTag(item, bt, j, SearchedFlightDetails.recordLocator, a);
                      } else if (bt.table.length > 1) {
                        zplCommand = getTSCPLCommandForConnectingBagTag(item, bt, j, SearchedFlightDetails.recordLocator, a);
                      }
                      console.log('zplCommand', zplCommand)
                      printerCommandsBT.push(zplCommand);
                    })
                  })
                  let cpj = new JSPM.ClientPrintJob();
                  cpj.clientPrinter = new JSPM.InstalledPrinter(bagtagPrinter.name);
                  cpj.printerCommands = printerCommandsBT.join('\n');
                  cpj.onFinished = function (data) {
                    console.log(`onFinished event foor printing ${bagtagPrinter.name}`, data);
                    // if (data && data.result && data.result === 'ClientPrintJob done') {
                    onPrintFinish("BT");
                    // }
                  };
                  cpj.sendToClient();
                }
              }

            }
          }
        }
        // onPrintFinish("BT");
        /** --------------browser popup starts here------------ */
        // console.log('divContents bagTag', divContents);
        // '<meta charset="utf-8" />' +
        // '<meta http-equiv="cache-control" content="no-cache">' +
        // '<meta http-equiv="expires" content="0" />' +
        // '<meta http-equiv="pragma" content="no-cache" />' +
        // if (!bgTag) {
        //   console.log('if !bgTag');
        // let BT = window.open();
        // BT.document.open('', '','height=1728, width=1000');
        // BT.document.write('<!DOCTYPE html><html lang="en"><head>'+

        // '<style> @page {size: portrait;margin:0;* {-webkit-print-color-adjust: exact;}} </style> </head><body onafterprint="self.close()">'
        // ); //<body onafterprint="self.close()">
        // BT.document.write(divContents);
        // BT.document.write('</body></html>'); //</body>
        // BT.document.close();     
        // BT.print(); 
        // // BT.onafterprint = back;

        // // function back() {
        // //   BT.history.back();
        // // }
        // BT.close();
        // onPrintFinish("BT",BT);
        // } else {
        //   console.log('else !bgTag');
        //   const myWindow = window.open();
        //   myWindow.document.open('', '','height=1728, width=1000');
        //   myWindow.document.write('<!DOCTYPE html><html lang="en">');
        //   // myWindow.document.write(
        //   //   '<!DOCTYPE html><html lang="en"><head>'+
        //   //   '<meta charset="utf-8" />' +
        //   //   '<meta http-equiv="cache-control" content="no-cache">' +
        //   //   '<meta http-equiv="expires" content="0" />' +
        //   //   '<meta http-equiv="pragma" content="no-cache" />' +
        //   //   '<style> @page {size: portrait;margin:0;* {-webkit-print-color-adjust: exact;}} </style> </head>' +
        //   //   '<h1 style="color:red;"> Hello world! </h1></html>'
        //   // );
        //   myWindow.document.write(divContents);
        //   myWindow.document.write('</html>');
        //   myWindow.document.close();
        //   // setBgTagPrint(false);
        //   // myWindow.print(); 
        //   // myWindow.close();
        //   // onPrintFinish("BT",myWindow);
        // }
        /**--------------browser popup ends here------------------- */

      }

    }
  }, [BPVisibility, bgTag, bpPrint]);

  function openBagTagComponent() {
    fncPrintBagTags("ANDROIDPRINT", 'androidTest')
  }

  const getSSR = (seg) => {
    let ssrs = (seg.legs[0].ssrs == null || seg.legs[0].ssrs.length === 0) ? "" : seg.legs[0].ssrs.map((ssr, j) => ssr.ssrCode + " "
    );
    if (seg.hasInfant) {
      ssrs = ssrs.length ? ssrs + ", INFT" : 'INFT';
    }
    return ssrs.toString();
  }

  const getFlightTimings = (seg) => {
    let departTime = ("0" + new Date(seg.designator.departure).getHours()).slice(-2) + ":" + ("0" + new Date(seg.designator.departure).getMinutes()).slice(-2);
    let arrivalTime = ("0" + new Date(seg.designator.arrival).getHours()).slice(-2) + ":" + ("0" + new Date(seg.designator.arrival).getMinutes()).slice(-2);
    // let flightTimings = "   "+("0"+new Date(seg.designator.departure).getHours()).slice(-2)+":"+("0"+new Date(seg.designator.departure).getMinutes()).slice(-2)
    // +"-"+("0"+new Date(seg.designator.arrival).getHours()).slice(-2)+":"+("0"+new Date(seg.designator.arrival).getMinutes()).slice(-2)+" hrs";
    let departDate = new Date(seg.designator.departure);
    let arrivalDate = new Date(seg.designator.arrival);
    SearchedFlightDetails.journeys.forEach((jou, j) =>
      jou.segments.forEach((segment, i) => {
        if (seg.identifier.identifier === segment.identifier.identifier) {
          if (segment.legs.length > 1) {
            departTime = ("0" + new Date(segment.designator.departure).getHours()).slice(-2) + ":" + ("0" + new Date(segment.designator.departure).getMinutes()).slice(-2);
            arrivalTime = ("0" + new Date(segment.designator.arrival).getHours()).slice(-2) + ":" + ("0" + new Date(segment.designator.arrival).getMinutes()).slice(-2);
            departDate = new Date(segment.designator.departure);
            arrivalDate = new Date(segment.designator.arrival);
          }
          if (segment.legs[0].operationsInfo && segment.legs[0].operationsInfo.departureTimes && segment.legs[0].operationsInfo.departureTimes.estimated) {
            departTime = ("0" + new Date(segment.legs[0].operationsInfo.departureTimes.estimated).getHours()).slice(-2) + ":" + ("0" + new Date(segment.legs[0].operationsInfo.departureTimes.estimated).getMinutes()).slice(-2);
            departDate = new Date(segment.legs[0].operationsInfo.departureTimes.estimated);
          }
          if (segment.legs[0].operationsInfo && segment.legs[0].operationsInfo.estimatedArrivalTime) {
            arrivalTime = ("0" + new Date(segment.legs[0].operationsInfo.estimatedArrivalTime).getHours()).slice(-2) + ":" + ("0" + new Date(segment.legs[0].operationsInfo.estimatedArrivalTime).getMinutes()).slice(-2);
            arrivalDate = new Date(segment.legs[0].operationsInfo.estimatedArrivalTime);
          }
        }
      })
    )
    return { departTime, arrivalTime, departDate, arrivalDate };
  }

  const getFlightDuration = (departDate, arrivalDate) => {
    const d1 = new Date(departDate);
    const d2 = new Date(arrivalDate);
    const durationInHours = Math.floor((d2 - d1) / 36e5);
    let duration = ((((d2 - d1) / 36e5)) % 1) * 60;
    duration = Math.round(duration * 100) / 100;
    const durationInMinutes = parseInt((duration < 10 ? '0' : '') + duration, 10);
    return `${durationInHours}h ${durationInMinutes}m`;
  }

  const sendBoardingPassData = () => {
    sendMobileBPData();
  }

  const sendMobileBPData = async () => {
    const boardingPasses = [];
    // console.log('dummyDataForFlyBig', isFlyBig);
    let flybigApiResponse = '';
    // if (isFlyBig) {
    //   flybigApiResponse = await fncGetAllFlyBigSchedules();
    //   console.log('flybigApiResponse', flybigApiResponse);
    // }
    BoardingPassDataForTransfer.forEach(item => {
      item.boardingPasses.forEach(bp => {
        let paxData;
        bp.segments.forEach(seg => {
          const { departTime, arrivalTime, departDate, arrivalDate } = getFlightTimings(seg);
          const { designator } = seg.legs[0];
          let flightType = 'Direct';
          let arrivalTerminal = '';
          let departureTerminal = '';

          SearchedFlightDetails.journeys.forEach(j => {
            j.segments.forEach(seg => {
              seg.IsSelected && seg.legs.forEach(leg => {
                const { designator: legDes } = leg;
                if (designator.destination === legDes.destination && designator.origin === legDes.origin) {
                  arrivalTerminal = leg.legInfo.arrivalTerminal ? leg.legInfo.arrivalTerminal : '';
                  departureTerminal = leg.legInfo.departureTerminal ? leg.legInfo.departureTerminal : '';
                }
              })
            })
          })

          if (seg.legs.length > 1) {
            // flightType = 'Via';
            flightType = `Via ${designator.destination}`;
          }
          if (bp.segments.length > 1) {
            flightType = 'Direct';
          }
          // console.log('bp,', bp);
          let pax;
          pax = SearchedFlightDetails.passenger.find(p =>
            (bp.passenger.name.title && p.name.title)
              ? (`${bp.passenger.name.title}. ${bp.passenger.name.first} ${bp.passenger.name.last}` === `${p.name.title}. ${p.name.first} ${p.name.last}`
                ||
                (p.infant && `${bp.passenger.name.title}. ${bp.passenger.name.first} ${bp.passenger.name.last}` === `${p.infant.name.title}. ${p.infant.name.first} ${p.infant.name.last}`))
              : (`${bp.passenger.name.first} ${bp.passenger.name.last}` === `${p.name.first} ${p.name.last}`)
              ||
              (p.infant && `${bp.passenger.name.first} ${bp.passenger.name.last}` === `${p.infant.name.first} ${p.infant.name.last}`)
          );

          if (pax) {
            paxData = {
              paxName: bp.passenger.name.title ? `${bp.passenger.name.title}. ${bp.passenger.name.first} ${bp.passenger.name.last}` : `${bp.passenger.name.first} ${bp.passenger.name.last}`,
              pnr: item.recordLocator,
              paxKey: pax.passengerKey,
              seat: seg.legs[0].seat.designator,
              ssr: getSSR(seg),
              tier: bp.passenger.currentTier ? bp.passenger.currentTier : '',
              barCode: bp.passenger.barCode,
              sequenceNo: seg.legs[0].boarding.boardingSequence.toString(),
              boardingTime: ("0" + new Date(seg.boardingTime).getHours()).slice(-2)
                + ":" + ("0" + new Date(seg.boardingTime).getMinutes()).slice(-2),
              boardingGate: seg.departureGate === null ? 'VERIFY AT AIRPORT' : seg.departureGate,
              fromStationCode: seg.designator.originStationName,
              toStationCode: seg.designator.destinationStationName,
              flight: seg.identifier.carrierCode + "" + seg.identifier.identifier,
              departureTime: departTime,
              arrivalTime: arrivalTime,
              departureDate: departDate, //("0"+new Date(departDate).getDate()).slice(-2)+" "+monthNames[new Date(departDate).getMonth()]+" "+new Date(departDate).getFullYear(),
              arrivalDate: ("0" + new Date(arrivalDate).getDate()).slice(-2) + " " + monthNames[new Date(arrivalDate).getMonth()] + " " + new Date(arrivalDate).getFullYear(),
              flightDuration: getFlightDuration(departDate, arrivalDate),
              flightType,
              arrivalTerminal,
              departureTerminal,
              OperatedBy: seg.legs[0].operatedByText ? seg.legs[0].operatedByText : seg.transportationName
            }
            // if (isFlyBig && flybigApiResponse !== '') {
            //   const isflyBigFlight = checkIfFlybigFlight(flybigApiResponse.data, paxData);
            //   if (isflyBigFlight) {
            //     paxData.flight = `${paxData.flight}/${isflyBigFlight.OperatedByCarrierCode}${isflyBigFlight.OperatingFlightNo}`;
            //     paxData.IsFlyBig = isFlyBig;
            //   }
            // }
          }
        })
        console.log('paxData', paxData)
        boardingPasses.push(paxData);
      })
    })
    const smsModalCloseButton = document.getElementById('smsModalCloseButton');
    // console.log('boardingPasses', boardingPasses);
    fncMBPDetails(boardingPasses)
      .then((response) => {
        // console.log('fncMBPDetails', response);
        if (response.data === 'Boarding Pass Created Successfully' && response.status === 200) {
          // if (isphoneNumberPresent) {
          //   setSubmitButton(true);
          // } 
          setmbpGenerated(true);
        } else {
          notify('Something went wrong. Please try again after sometime.', 3000);
          smsModalCloseButton.click();
        }
      })
      .catch((err) => {
        console.log("Axios err in fncMBPDetails: ", err);
        notify('Something went wrong. Please try again after sometime.', 3000);
        smsModalCloseButton.click();
        // if (mobileBPApiFailCount > 3) {
        //   setMobileBPApiFailCount(mobileBPApiFailCount + 1);
        // } else {

        // }
      });
  }

  function getPaxName(pax) {
    // debugger
    let p;
    if (pax.name.title !== null || pax.name.title !== '') {
      p = `${pax.name.last}, ${pax.name.first} ${pax.name.title}`;
    } else {
      p = `${pax.name.last}, ${pax.name.first}`
    }
    return p
  }

  function fncOpenModalPopup() {
    setModalShow(true);
  }
  function fncSelectUncheckOption(e, id) {
    let data = [...st_UnCheckPassenger]
    let IsChecked = false;
    for (let i = 0; i < data.length; i++) {
      if (data[i].Id == id) {
        if (e.target.checked == true) {
          data[i].IsChecked = true;
        }
        else {
          data[i].IsChecked = false;
        }
      }
      if (data[i].IsChecked) {
        IsChecked = true;
      }
    }
    // if(IsChecked)
    // {
    //   setUnCheckButton(false)
    // }
    // else
    // {
    //   setUnCheckButton(true)
    // }
    setUnCheckPassenger(data);
  }

  async function fncCheckInBaggages(MES) {
    let recordlocator = SearchedFlightDetails.recordLocator;
    FncSearchApi("", "", "", "", "", recordlocator, true, "", "", "")
      .then((returnVal) => {

        if (returnVal.status == "401" && returnVal.data == "") {
          document.getElementById("showAndHideSpinner").style.display = "none";
          settriggerModal(true);
        }
        else {
          if (returnVal.data.isError == false) {
            let assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "AUTOSEATASSIGN");

            dispatch(searchCredential(
              {
                type: "",
                SearchedRecordData: stSearchedRecordData,
                SearchedFlightDetails: assignStateAgain
              }
            ));
            dispatch(bagCredential(
              {
                type: "BAG_ADDED",
                isBagAdded: 0
              }
            ));
            // debugger;
            if (MES == "FROMCHECKIN") {
              fncShowAndHideBP("FROMCHECKIN");
            }
            else if (MES == "FROMCOMMITBAGGAGE") {
              fncReprintBagTag("FROMCOMMITBAGGAGE", assignStateAgain);
            }
          }
          else {
            document.getElementById("showAndHideSpinner").style.display = "none";
            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
              settriggerModal(true);
            } else {
              notify(returnVal.data.errorDetail.errorMessage);
            }
          }
          document.getElementById("showAndHideSpinner").style.display = "none";
        }

      })
      .catch(err => console.log("Axios err: ", err))
  }

  function goToSearch() {
    doClose()
    dispatch(searchCredential(
      {
        type: "",
        SearchedRecordData: [],
        SearchedFlightDetails: {}
      }
    ));

    dispatch(selectedpassengerCredential(
      {
        type: "",
        SelectedPassengerData: {},

      }
    ));
    dispatch(printerPopupSearchPageCredential(
      {
        type: "",
        isPrinterPopupSearchPageOpen: false,

      }
    ));

    history.push('/Search')

  }

  // Focus first checkbox when dropdown opens
  useEffect(() => {
    if (passengerRef.current.length > 0) {
      passengerRef.current[0]?.focus();
    }
  }, []);

  const Bluetoothaddresspopup = async () => {
    doClose()
  }

  const handleKeyDown = (event, index, ref) => {
    const container = ref.current[index];
    if (!container) return;
    const clearButton = document.querySelector(".clear-selected-button");
    if (clearButton) {
      clearButton.tabIndex = -1; // Prevent focus on Tab key press
    }
    document.querySelectorAll(".select-item").forEach((label) => {
      label.classList.add("checkbox-input");
    });

    const checkboxes = container.querySelectorAll(".checkbox-input");
    const lastIndex = checkboxes.length - 1;
    if (checkboxes.length === 0) return;

    if (event.key === "Tab") {
      event.preventDefault();
      let nextIndex = event.shiftKey ? (index > 0 ? index - 1 : lastIndex) : (index < lastIndex ? index + 1 : 0);

      setFocusedIndex(nextIndex);
      checkboxes[nextIndex]?.classList.add("focused-checkbox");
      checkboxes[nextIndex]?.focus();
    }
  };

  useEffect(() => {
    const clearButton = document.querySelector(".clear-selected-button");
    if (clearButton) {
      clearButton.tabIndex = -1; // Prevent focus on Tab key press
    }
  });

  useEffect(() => {
    if (selectedMode === 'SITA FLEX' && sitaFlexLocationId !== '') {
      debugger
      fncSitaFlexGetTokenOrStatus({
          LocationId: sitaFlexLocationId,
          Type: "GD" 
          })
          .then((response) => {
              console.log('fncMBPDetails', response);
              if (response.status == "401" && response.data == "") {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  settriggerModal(true);
              } else {
                  if (response.status == 200) {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    console.log('returnVal.data', response.data);
                    localStorage.setItem('SITAPrinters', JSON.stringify(response.data));
                  } else {
                      document.getElementById("showAndHideSpinner").style.display = "none";
                      const dummy = [ 

                          { 
                          
                          "deviceId": "A-JAF-JAF1WLB006.ATB1", 
                          
                            "deviceStatus": "Online", 
                          
                          "mediaStatus": "Ok", 
                          
                          "binStatus": "Ok" 
                          
                          }, 
                          
                          { 
                          
                            "deviceId": "A-JAF-JAF1WLB006.BTP1", 
                          
                            "deviceStatus": "Online", 
                          
                            "mediaStatus": "Ok", 
                          
                            "binStatus": "Ok" 
                          
                          } 
                          
                          ]

                          // setsitaFlexPrinter(dummy);
                          localStorage.setItem('SITAPrinters', JSON.stringify(dummy));
                      // if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                      //   settriggerModal(true);
                      // } else {
                      //   notify(returnVal.data.errorDetail.errorMessage);
                      // }
                  }
              }
              
            })
            .catch((err) => {
              console.log("Axios err in fncSitaFlexGetTokenOrStatus: ", err);
              notify('Something went wrong. Please try again after sometime.', 3000);
          });
    }
  }, [])

  useEffect(() => {
    if (printingBoardingPassFrom === 'PRINT' && selectedMode === 'SITA FLEX' && sitaFlexLocationId !== '') {
      const sitaPrinters = JSON.parse(localStorage.getItem('SITAPrinters'));
      console.log('sitaPrinters local storage', sitaPrinters);
      if ((sitaPrinters?.filter(p => p.deviceStatus === 'Online' && p.deviceId.includes('ATB')).length || 0) > 0) {
        const bpSitaFormatString = generateReferenceStringForBoardingPass(BoardingPassDataForTransfer);
        console.log('bpSitaFormatString in reprint boardingpass', bpSitaFormatString);
  
        const bpRequest = bpSitaFormatString.map((b) => {
          return {printData: b}
        });

        console.log('bpRequest', bpRequest);
  
        fncSitaFlexPrintCall({
          LocationId: sitaFlexLocationId,
          boardingPass: bpRequest,
          baggageTag: []
        })
        .then((response) => {
          console.log('response printing', response);
          if (response.status == "401" && response.data == "") {
            document.getElementById("showAndHideSpinner").style.display = "none";
            settriggerModal(true);
          } else {
            if (response.data.isError) {
              console.log(" err in fncSitaFlexPrintCall: ", e);
              document.getElementById("showAndHideSpinner").style.display = "none";
              notify(response.data.errorDetail.errorMessage, 3000);
            }
            else if (response.status == 200) {
              document.getElementById("showAndHideSpinner").style.display = "none";
              notifySuccess(response.data);
              window.location.reload();
            }
          }
        })
        .catch((e) =>  {
          console.log("Axios err in fncSitaFlexPrintCall: ", e);
          document.getElementById("showAndHideSpinner").style.display = "none";
          notify('Something went wrong. Please try again after sometime.', 3000);
        })
      }
      else {
        notify('Boarding Pass printer is not online');
      }
      
    }
  }, [printingBoardingPassFrom]);

  useEffect(() => {
    if (['FROMCOMMITBAGGAGE', 'PRINT'].includes(printBagTagFrom) && selectedMode === 'SITA FLEX' && sitaFlexLocationId !== '') {
      const sitaPrinters = JSON.parse(localStorage.getItem('SITAPrinters'));
      console.log('sitaPrinters local storage', sitaPrinters);
      if ((sitaPrinters?.filter(p => p.deviceStatus === 'Online' && p.deviceId.includes('BTP')).length || 0) > 0) {
        const btSitaFormatString = generateReferenceStringForBagTag(AddBags, SearchedFlightDetails);
        console.log('btSitaFormatString', btSitaFormatString);
        const btRequest = btSitaFormatString.map((b) => {
          return {printData: b}
        });

        console.log('btRequest', btRequest);
  
        fncSitaFlexPrintCall({
          LocationId: sitaFlexLocationId,
          boardingPass: [],
          baggageTag: btRequest
        })
        .then((response) => {
          console.log('response printing', response);
          if (response.status == "401" && response.data == "") {
            document.getElementById("showAndHideSpinner").style.display = "none";
            settriggerModal(true);
          } else {
            if (response.data.isError) {
              console.log(" err in fncSitaFlexPrintCall: ", e);
              document.getElementById("showAndHideSpinner").style.display = "none";
              notify(response.data.errorDetail.errorMessage, 3000);
            }
            else if (response.status == 200) {
              document.getElementById("showAndHideSpinner").style.display = "none";
              notifySuccess(response.data);
              window.location.reload();
            }
          }
        })
        .catch((e) =>  {
          console.log("Axios err in fncSitaFlexPrintCall: ", e);
          document.getElementById("showAndHideSpinner").style.display = "none";
          notify('Something went wrong. Please try again after sometime.', 3000);
        })
      }
      else {
        notify('BagTag printer is not online');
      }
    }
  }, [printBagTagFrom, selectedMode]);

  const fncPrintSitaBothBPandBT = (bpData) => {
    let boardingPassToPrint = bpData;
    const sitaPrinters = localStorage.getItem('SITAPrinters');
    console.log('sitaPrinters local storage', sitaPrinters);
    if (boardingPassToPrint === "") {
      boardingPassToPrint = [...BoardingPassDataForTransfer];
    }
    for (let i = 0; i < boardingPassToPrint.length; i++) {
      for (let k = 0; k < boardingPassToPrint[i].boardingPasses.length; k++) {
        let segments = boardingPassToPrint[i].boardingPasses[k].segments;
        for (let j = 0; j < segments.length; j++) {
          segments[j].IsSelected = true;;
        }
      }
    }

    const checkedBags = getCheckedBaggageKeys(SearchedFlightDetails);
    let bagTagToPrint = [];
    bagTagToPrint = [...AddBags];
    for (let i = 0; i < bagTagToPrint.length; i++) {
      let bags = bagTagToPrint[i].bags;
      for (let j = 0; j < bags.length; j++) {
        if (checkedBags.includes(bags[j].baggageKey)) {
          bags[j].IsSelected = true;
        }
      }
    }
    const bagData = bagTagToPrint.filter(pax => pax.IsSelected && pax.bags.some(bag => bag.IsSelected));
    if (bagData.length === 0) {
      window.location.reload();
    }
    console.log('boardingPassToPrint', boardingPassToPrint, 'bagData', bagData);
    const bpSitaFormatString = generateReferenceStringForBoardingPass(boardingPassToPrint);
    const btSitaFormatString = generateReferenceStringForBagTag(bagData, SearchedFlightDetails);
    console.log('bpSitaFormatString', bpSitaFormatString);
    console.log('btSitaFormatString', btSitaFormatString);
    const bpRequest = bpSitaFormatString.map((b) => {
     return {printData: b}
    })

    const btRequest = btSitaFormatString.map((b) => {
      return {printData: b}
     })
     debugger
    fncSitaFlexPrintCall({
      LocationId: sitaFlexLocationId,
      boardingPass: bpRequest,
      baggageTag: btRequest
    })
    .then((response) => {
      console.log('response printing', response);
      if (response.status == "401" && response.data == "") {
        document.getElementById("showAndHideSpinner").style.display = "none";
        settriggerModal(true);
      } else {
        if (response.data.isError) {
          console.log(" err in fncSitaFlexPrintCall: ", e);
          document.getElementById("showAndHideSpinner").style.display = "none";
          notify(response.data.errorDetail.errorMessage, 3000);
        }
        else if (response.status == 200) {
          document.getElementById("showAndHideSpinner").style.display = "none";
          notifySuccess(response.data);
          window.location.reload();
        }
      }
    })
    .catch((e) =>  {
      console.log("Axios err in fncSitaFlexPrintCall: ", e);
      notify('Something went wrong. Please try again after sometime.', 3000);
    })
  }

  return (
    <div>
      <LogoutModel trigger={triggerModal}> </LogoutModel>
      {/* && !passengerUncheckDone && !CheckInPassenger */}
      <DocumentVerificationModal trigger={!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule && !docVerified && haveTravelDocs(SearchedFlightDetails) && !CheckInPassenger && !passengerUncheckDone}></DocumentVerificationModal>
      {

        BPVisibility == "BP" && selectedMode == "Native" ? <BoardingPass data={BoardingPassDataForTransfer} /> :
          BPVisibility == "BT" && selectedMode == "Native" ? <BagTag data={AddBags} /> :

            <div class="finalize-container">
              <div class="row">
                <div class="col-lg-7 mt-3">
                  <div class="card finalize-card" tabIndex={-1}>
                    <div class="heading border-bottom mb-3 pb-3">
                      <h4 class="font-xxl bold dark-text mb-0">
                        Flight Details
                      </h4>
                    </div>
                    {
                      SearchedFlightDetails.journeys != undefined ?
                        SearchedFlightDetails.journeys.length == 0 ? "" :
                          SearchedFlightDetails.journeys.map((jou, j) =>
                            <div>
                              {
                                jou.segments.map((seg, i) =>
                                  seg.IsSelected ?
                                    <div>
                                      <div class="finalize-fDetails">
                                        <div class="finalize-fDetails-items">
                                          <p class="font-sm bold mb-1">Flight No.</p>
                                          <p class="font-sm mb-0">{seg.identifier.carrierCode + " " + seg.identifier.identifier}</p>
                                        </div>
                                        <div class="finalize-fDetails-items">
                                          <p class="font-sm bold mb-1">Route</p>
                                          <p class="font-sm mb-0">{seg.designator.origin + "-" + seg.designator.destination}</p>
                                        </div>
                                        <div class="finalize-fDetails-items">
                                          <p class="font-sm bold mb-1">Date</p>
                                          <p class="font-sm mb-0">{seg.legs[0].operationsInfo && seg.legs[0].operationsInfo.departureTimes.estimated ?
                                            moment(new Date(seg.legs[0].operationsInfo.departureTimes.estimated)).format("ddd, DoMMM") : moment(seg.designator.departure).format("ddd, DoMMM")}</p>
                                        </div>
                                        <div class="finalize-fDetails-items">
                                          <p class="font-sm bold mb-1">Flight Time</p>
                                          <p class="font-sm mb-0">
                                            {
                                              `${seg.legs[0].operationsInfo && seg.legs[0].operationsInfo.departureTimes.estimated ?
                                                moment(new Date(seg.legs[0].operationsInfo.departureTimes.estimated)).format("HH:mm") :
                                                moment(seg.designator.departure).format("HH:mm")} - 
                                              ${seg.legs[0].operationsInfo && seg.legs[0].operationsInfo.estimatedArrivalTime ?
                                                moment(new Date(seg.legs[0].operationsInfo.estimatedArrivalTime)).format("HH:mm") :
                                                moment(seg.designator.arrival).format("HH:mm")}`
                                            }
                                          </p>
                                        </div>
                                      </div>
                                      <div class="finalize-fDetails">
                                        <div class="finalize-fDetails-items">
                                          <p class="font-sm bold mb-1">Gate No.</p>
                                          <p class="font-sm mb-0">{seg.legs[0].operationsInfo == null ? "" : seg.legs[0].operationsInfo.departureGate == null ? "" : seg.legs[0].operationsInfo.departureGate.actualGate == null ? "" : seg.legs[0].operationsInfo.departureGate.actualGate}</p>
                                        </div>
                                        <div class="finalize-fDetails-items">
                                          <p class="font-sm bold mb-1">Boarding Time</p>
                                          <p class="font-sm mb-0">{seg.designator.boardingTime == null ? "" :
                                            seg.legs[0].operationsInfo && seg.legs[0].operationsInfo.departureTimes.estimated ? moment(new Date(seg.legs[0].operationsInfo.departureTimes.estimated)).subtract(process.env.REACT_APP_BOARDING_TIME_BEFORE_DEPARTURE, 'minutes').format("HH:mm") : moment(seg.designator.boardingTime).format("HH:mm")}</p>
                                        </div>
                                        <div class="finalize-fDetails-items">
                                          <p class="font-sm bold mb-1">Special</p>
                                          <p class="font-sm mb-0">--</p>
                                        </div>
                                        <div class="finalize-fDetails-items">
                                          <p class="font-sm bold mb-1">Flight Status</p>
                                          <p class="font-sm mb-0 primary-text">{seg.legs[0].status === 'Normal' ? 'Open' : seg.legs[0].status}</p>
                                        </div>
                                      </div>
                                    </div>
                                    : ""
                                )
                              }
                            </div>
                          ) : ""
                    }

                    <div class="f-pDetails mt-4">
                      <h4 class="font-xl bold dark-text mb-0">
                        Passenger Details
                      </h4>
                      <div class="ptable-data">
                        <div class="headings">
                          <div class="name">Name</div>
                          <div class="seatNo">Seat No.</div>
                          <div class="sequenceNo">Sequence No.</div>
                          <div class="bagCount">Bags Pc/Wt(Kg)</div>
                          <div class="ssr">SSR(S)</div>
                          <div class="status">PAX Status</div>
                        </div>
                        {
                          SearchedFlightDetails.passenger !== undefined ?
                            SearchedFlightDetails.passenger.length === 0 ? "" :
                              SearchedFlightDetails.passenger.map((pax, paxcount) =>
                                pax.IsSelected ?
                                  <div class="pTable-scroll-body mb-0">
                                    <div class=" table-item bag-item">
                                      <div class="name">
                                        <label>Name</label>
                                        <p>  {getPaxName(pax)}   </p>
                                        {pax.infant ?
                                          <div>
                                            <img class="infantIcon" data-tip data-for={`${pax.infant.name.first}${paxcount}`} src="newImages/infant-red.svg" />
                                            <ReactTooltip id={`${pax.infant.name.first}${paxcount}`} place="top" effect="solid">
                                              {pax.infant.name.last}, {pax.infant.name.first} {pax.infant.name.title}
                                            </ReactTooltip>
                                          </div>
                                          : null
                                        }
                                      </div>
                                      <div class="seatNo">
                                        <label>Seat No.</label>
                                        <p>
                                          {
                                            SearchedFlightDetails.journeys
                                              .flatMap(jou =>
                                                jou.segments.flatMap(seg =>
                                                  seg.passengerSegment.filter(paxseg =>
                                                    paxseg.passengerKey === pax.passengerKey && paxseg.IsSelected && paxseg.seats.length > 0
                                                  ).map(paxseg => paxseg.seats[0].unitDesignator)
                                                ))
                                              .join(', ')}
                                        </p>
                                      </div>
                                      <div class="sequenceNo"> <label>Sequence No.</label>
                                        <p>{fncSeqNo(SearchedFlightDetails, pax.passengerKey)}</p>
                                      </div>
                                      <div class="bagCount"> <label>Bags Pc/Wt(Kg)</label>
                                        <p>
                                          {
                                            fncBagCount(SearchedFlightDetails, pax.passengerKey)
                                          }
                                        </p>
                                      </div>
                                      <div class="ssr"> <label>SSR(S)</label>
                                        <p>{fncSSR(SearchedFlightDetails, pax.passengerKey)}</p>
                                      </div>
                                      <div class="status">
                                        <label>PAX Status</label>
                                        {SearchedFlightDetails.journeys.map((jou, j) =>
                                          jou.segments.map((seg, i) =>
                                            i == 0 ? seg.passengerSegment.map((paxseg, loop) =>
                                              paxseg.passengerKey == pax.passengerKey && paxseg.IsSelected == true ? <p>{paxseg.liftStatus == "Default" ? "Not Checked In" : paxseg.liftStatus == "CheckedIn" ? "Checked In" : paxseg.liftStatus == "Boarded" ? "Boarded" : ""}</p> : ""
                                            ) : ""
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </div> : ""
                              ) : ""
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5 mt-3">
                  <div class="searchNewPassenger">
                    <div class="card finalize-card quickLinks ">
                      <div class="row">
                        <div class="col-4 mb-3">
                          <button class="focusClass quick-link-card w-100 OrangeShadow" disabled={CheckInPassenger} onClick={fncCheckInPassenger} ref={!CheckInPassenger ? checkInPassengersOrSaveChangesRef : null}>
                            <div class="icon">
                              <img src="newImages/icon-checkInPassengers.svg" alt="checkInPassengers" />
                            </div>
                            <p>Check in Passengers</p>
                          </button>
                        </div>
                        <div class="col-4 mb-3">
                          <button class="focusClass quick-link-card w-100 OrangeShadow" onClick={() => { fncSaveChanges("WITHCHECKINBAGGAGE") }} ref={CheckInPassenger ? checkInPassengersOrSaveChangesRef : null}>
                            <div class="icon">
                              <img src="newImages/icon-save.svg" alt="save" />
                            </div>
                            <p>Save Changes</p>
                          </button>
                        </div>
                        <div class="col-4 mb-3">
                          <button class="focusClass quick-link-card w-100 OrangeShadow" disabled={UnCheckInBags} onClick={() => fncCommitBaggage()}>
                            <div class="icon">
                              <img src="newImages/icon-commit-baggage.svg" alt="commit-baggage" />
                            </div>
                            <p>Commit Baggage</p>
                          </button>
                        </div>
                        <div class="col-4 mb-3">
                          <button class="focusClass quick-link-card w-100 OrangeShadow" disabled={CheckInBags} data-toggle="modal" data-target="#BagTagPopup" onClick={() => fncReprintBagTag("MODALOPEN", "")}>
                            <div class="icon">
                              <img src="newImages/icon-reprint-tag.svg" alt="reprint-tag" />
                            </div>
                            <p>Reprint Bag Tag</p>
                          </button>
                        </div>
                        <div class="col-4 mb-3">
                          <button class="focusClass quick-link-card w-100 OrangeShadow" disabled={UnCheckInAllowed} data-toggle="modal" data-target="#BoardingPassPopup" onClick={() => fncShowAndHideBP("FOPUP")}>
                            <div class="icon">
                              <img src="newImages/icon-reprint-boarding-pass.svg" alt="reprint-boarding-pass" />
                            </div>
                            <p>Reprint Boarding Pass</p>
                          </button>
                        </div>
                        <div class="col-4 mb-3">
                          <button class="focusClass quick-link-card w-100 OrangeShadow" data-toggle="modal" data-target="#bluetoothaddress" disabled={true}
                          >

                            <div class="icon">
                              <img src="newImages/icon-reprintReceipt.svg" alt="reprintReceipt" />
                            </div>
                            <p>Reprint Receipt</p>
                          </button>
                        </div>
                        <div class="col-4 mb-3">
                          <button class="focusClass quick-link-card w-100 OrangeShadow" disabled={UnCheckInAllowed} onClick={fncOpenModalPopup}>
                            <div class="icon">
                              <img src="newImages/icon-uncheckPassangers.svg" alt="uncheckPassangers" />
                            </div>
                            <p>Uncheck Passangers</p>
                          </button>
                        </div>
                        <div class="col-4 mb-3">
                          <button class="focusClass quick-link-card w-100 OrangeShadow" disabled={true} >
                            {/* disabled={UnCheckInAllowed} onClick={openBoardingPassComponent} */}
                            <div class="icon">
                              <img src="newImages/icon-paymentReceipt.svg" alt="paymentReceipt" />
                            </div>
                            <p>Payment Receipt</p>
                          </button>
                        </div>
                        <div class="col-4 mb-3">
                          <button class="focusClass quick-link-card w-100 OrangeShadow" data-toggle="modal" data-target="#onlineMedium" onClick={sendBoardingPassData} disabled={UnCheckInAllowed}>
                            {/* disabled={CheckInBags}  disabled=UnCheckInAllowed */}
                            <div class="icon">
                              <img src="newImages/icon-smsPush.svg" alt="smsPush" />
                            </div>
                            <p>SMS Push</p>
                          </button>
                        </div>
                      </div>
                    </div>
                    <a tabIndex={0} class="focusClass btn btn-secondary nextPassengerBtn btn-animation SerachBtn" onClick={goToSearch}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          goToSearch();
                        }
                      }}>
                      <span class="px-4"> Search New Passenger<span class="icon ms-2"><img src="newImages/i-arrow-right.svg" /> <img src="newImages/i-arrow-right.svg" /></span></span>
                    </a>
                  </div>

                </div>
              </div>
            </div>
      }

      <div class="modal fade " id="onlineMedium" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true" data-bs-backdrop="static" data-dismiss="modal" data-toggle="modal">
        <div class="modal-dialog modal-dialog-centered onlineMedium-content">
          <div class="modal-content">
            <div class="heading" tabIndex={-1}>
              <a data-dismiss="modal" id="smsModalCloseButton" class="modal-close">
                <img src="newImages/i-cross.svg" alt="cross" />
              </a>
              <h4 class="font-xxl bold dark-text mb-0">Update Passenger Info As Required</h4>
            </div>
            <div class="onlineMedium-data">
              <table class="table">
                <thead>
                  <tr>

                    {
                      passengersForSMSPush.length > 1 ?
                        <th class="font-sm bold dark-text">
                          <input class=" form-check-input checkbox-input" type="checkbox" onChange={(e) => fncSelectAllPaxForSMS(e)} checked={selectAllPaxForSMS} />
                        </th> :
                        null
                    }
                    <th class="font-sm bold dark-text">Name</th>

                    <th class="font-sm bold dark-text">Phone No.</th>
                    <th class="font-sm bold dark-text">Email ID</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    passengersForSMSPush.length > 0 ?
                      passengersForSMSPush.map((item, i, pArr) =>
                        <tr>
                          {
                            pArr.length > 1 ?
                              <td class="font-sm mid-dark-text">
                                <input class=" form-check-input checkbox-input" id={item.passengerKey} type="checkbox" onChange={(e) => fncSelectSMSPax(e, item)} checked={item.isChecked} />
                              </td> : null
                          }
                          <td class="font-sm mid-dark-text">
                            {`${item.name.title} ${item.name.first} ${item.name.last}`}
                          </td>
                          <td class="font-sm mid-dark-text">
                            {
                              pArr.length > 1 ?
                                <input disabled={!item.isChecked} value={item.phone} onChange={(e) => fncPhone(e, item)} class="form-control" type="text" /> :
                                <input value={item.phone} onChange={(e) => fncPhone(e, item)} class="form-control" type="text" />
                            }
                          </td>
                          <td class="font-sm mid-dark-text">
                            {
                              pArr.length > 1 ?
                                <input disabled={!item.isChecked} value={item.email} onChange={(e) => fncEmail(e, item)} class="form-control" type="text" /> :
                                <input value={item.email} onChange={(e) => fncEmail(e, item)} class="form-control" type="text" />
                            }
                          </td>
                        </tr>
                      )

                      : null
                  }
                </tbody>
              </table>
              {/* <a class="btn btn-primary mt-3" onClick={updateAddress}>Update</a> */}
            </div>
            <div class="online-medium-content">
              <div class="online-medium-inputs">
                <div class="form-group">
                  <input id="sms" type="checkbox" checked={sendSMSEnabled} onChange={(e) => setsendSMSEnabled(e.target.checked)} class="form-check-input me-2 checkbox-input" />
                  {/* checked={sendSMSEnabled} onChange={(e) => setsendSMSEnabled(e.target.checked)}  */}
                  <label for="sms">SMS</label>
                </div>
                <div class="form-group">
                  <input id="email" type="checkbox" checked={sendEmailEnabled} onChange={(e) => setsendEmailEnabled(e.target.checked)} class="form-check-input me-2 checkbox-input" />
                  <label for="email">Email</label>
                </div>
                <div class="form-group">
                  <input id="whatsApp" type="checkbox" checked={sendWhatsappEnabled} onChange={(e) => setsendWhatsappEnabled(e.target.checked)} class="form-check-input me-2 checkbox-input" />
                  <label for="whatsApp">WhatsApp</label>
                </div>
              </div>
              <div class="d-flex align-items-center mt-4">
                <button disabled={!(mbpGenerated && (sendSMSEnabled || sendEmailEnabled || sendWhatsappEnabled))} onClick={sendBP} class="btn btn-primary me-4 SerachBtn">
                  Submit
                </button>
                <button data-dismiss="modal" class="btn btn-primary SerachBtn">Cancel</button>
              </div>
              <div class="d-flex align-items-center mt-4">
                {mbpGenerated ?
                  <p> Please select SMS and hit submit to send </p> :
                  <p> Wait for some time</p>
                }
              </div>
            </div>

          </div>
        </div>
      </div>

      <div data-backdrop="static" data-keyboard="false" class="modal right fade rePrintBagTag" id="BagTagPopup" tabIndex={-1} role="dialog" aria-labelledby="rePrintBagTag">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header border-0">
              <div class="modal-title"><strong>Re-Print Bag Tag</strong></div>
              <a id="modalCloseReprintBag" class="close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times checkbox-input"></i></a>
            </div>
            <FocusLock disabled={!Bagtagpopup}>
              <div class="modal-body">
                <div class="row mx-0 ">
                  <div class="col-6">
                    <h6 class="mb-0 mt-0">Print which bag tag?</h6>
                  </div>
                  <div className="col-6">
                    <input type="checkbox"
                      class="mr-2 checkbox-input"
                      checked={selectAllBagsToPrint}
                      // id={cp.Id}
                      id='selectallOfbagtag'
                      // disabled={cp.IsDisabled}
                      onChange={(e) => { fnSelectAllBagsToPrint(e) }}
                    />
                    Select All
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 sp-tab-content">


                    {AddBags.length == 0 ? "" : AddBags.map((item, i) =>
                      item.IsSelected == true ?
                        <div class="col-12 sp-red-box-card-list mt-4">
                          <div class="card">
                            <div class="card-header px-3">
                              <strong>  {item.name.last + "," + item.name.first + " " + item.name.title}</strong>
                            </div>


                            <div class="card-body p-3">
                              {item.bags.length == 0 ? "" : item.bags.map((bags, j) => fncBagStatus(SearchedFlightDetails, bags.baggageKey, item.passengerKey, "WEIGHTCHECK").toUpperCase() == "CHECKED".toUpperCase() ?
                                <div className="row">
                                  <div class="col-6 col-lg-4 mb-3 mb-lg-0">
                                    <div class="d-block w-100 text-uppercase text-color-black font-semiBold pb-1">
                                      <input type="checkbox" class="mr-1 checkbox-input" checked={bags.IsSelected} onChange={(e) => { fncSelectedBagTag(e, bags.osTag) }} />
                                      Bags</div>
                                    <div class="d-block w-100 sp-ulist-data text-nowrap">      {bags.osTag} </div>
                                  </div>
                                  <div class="col-6 col-lg-4 mb-3 mb-lg-0">
                                    <div class="d-block w-100 text-uppercase text-color-black font-semiBold pb-1">Weight</div>
                                    <div class="d-block w-100 sp-ulist-data"> {bags.weight} Kg</div>
                                  </div>
                                  <div class="col-6 col-lg-4 mb-3 mb-lg-0">
                                    <div class="d-block w-100 text-uppercase text-color-black font-semiBold pb-1">Status</div>
                                    <div class="d-block w-100 sp-ulist-data">{fncBagStatus(SearchedFlightDetails, bags.baggageKey, item.passengerKey, "")} </div>
                                  </div>
                                </div> : ""
                              )
                              }
                            </div>
                          </div>
                        </div>
                        : ""
                    )}

                    <div class="col-12 mt-4">
                      <button disabled={isBagTagPrint} onClick={() => fncPrintBagTags("PRINT")} type="button" class="btn btn-red px-4 d-block w-100 text-uppercase SerachBtn" >Print</button>
                    </div>
                    <div class="col-12 mt-4">
                      <button type="button" data-toggle="modal" id="btnCloseButton" data-target="#BagTagPopup" class="btn btn-red px-4 d-block w-100 text-uppercase SerachBtn" >Close</button>
                    </div>
                  </div>
                </div>
              </div>
            </FocusLock>
          </div>
        </div>
      </div>
      <div data-backdrop="static" data-keyboard="false" class="modal right fade BoardingPassPopup" id="BoardingPassPopup" tabIndex={-1} role="dialog" aria-labelledby="BoardingPassPopup">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header border-0">
              <div class="modal-title"><strong>Re-Print Boarding Pass</strong></div>
              <a id="modalCloseReprintBoardingPass" class="close checkbox-input" data-dismiss="modal" aria-label="Close"><i class="fa fa-times"></i></a>
            </div>
            <FocusLock disabled={!Boardingpopup}>
              <div class="modal-body">
                <div class="row mx-0 ">
                  <div class="col-6">
                    <h6 class="mb-0 mt-0">Print which boarding pass?</h6>
                  </div>
                  <div className="col-6">
                    <input type="checkbox"
                      class="mr-2 checkbox-input"
                      checked={selectAllBPToPrint}
                      // id={cp.Id} 
                      id="selectAllinrecept"
                      // disabled={cp.IsDisabled}
                      onChange={(e) => { fnSelectAllBPToPrint(e) }}
                    />
                    Select All
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 sp-tab-content">


                    {
                      BoardingPassDataForTransfer.length == 0 ? "" : BoardingPassDataForTransfer.map((item, i) =>
                        item.boardingPasses.length == 0 ? "" : item.boardingPasses.map((bp, j) =>
                          bp.segments.length == 0 ? "" : bp.segments.map((seg, k) =>
                            <div class="col-12 sp-red-box-card-list mt-4">
                              <div class="card">
                                {k === 0 ?
                                  <div class="card-header px-3">
                                    <strong>
                                      {bp.passenger.name.title
                                        ?
                                        `${bp.passenger.name.title} . ${bp.passenger.name.last} ${bp.passenger.name.first}`
                                        :
                                        `${bp.passenger.name.last} ${bp.passenger.name.first}`}
                                      {/* {bp.passenger.name.title ? bp.passenger.name.title + ". " : ''  + bp.passenger.name.last + " " + bp.passenger.name.first} */}
                                    </strong>
                                  </div>
                                  : ""}
                                <div class="card-body p-3">
                                  <div class="row">
                                    <div class="col-6 col-lg-4 mb-3 mb-lg-0">
                                      <div class="d-block w-100 text-uppercase text-color-black font-semiBold pb-1">
                                        <input className='checkbox-input' type="checkbox" checked={seg.IsSelected} onChange={(e) => { fncSelectedBoardingPasses(e, bp.passenger.barCode != null ? bp.passenger.barCode.replace(/ /g, '') : null) }} /> Flight
                                        {/* <input type="checkbox" checked={seg.IsSelected} onChange={(e) => { fncSelectedBoardingPasses(e, bp.passenger.barCode != null ? passenger.barCode : null) }} /> Flight */}
                                      </div>
                                      <div class="d-block w-100 sp-ulist-data text-nowrap">{seg.identifier.carrierCode + "" + seg.identifier.identifier}</div>
                                    </div>
                                    <div class="col-6 col-lg-4 mb-3 mb-lg-0">
                                      <div class="d-block w-100 text-uppercase text-color-black font-semiBold pb-1">Date</div>
                                      <div class="d-block w-100 sp-ulist-data">
                                        {"  " + ("0" + new Date(seg.designator.departure).getDate()).slice(-2) + " " + monthNames[new Date(seg.designator.departure).getMonth()] + " " + new Date(seg.designator.departure).getFullYear()}
                                      </div>
                                    </div>
                                    <div class="col-6 col-lg-4 mb-3 mb-lg-0">
                                      <div class="d-block w-100 text-uppercase text-color-black font-semiBold pb-1">Status</div>
                                      <div class="d-block w-100 sp-ulist-data">{seg.legs[0].liftStatus}</div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          )
                        )
                      )
                    }
                    <div class="col-12 mt-4">
                      <button disabled={isBoardingPassPrint} onClick={() => fncPrintButtonClick("PRINT", "")} type="button" class="focusClass btn btn-red px-4 d-block w-100 text-uppercase SerachBtn" >Print</button>
                    </div>
                    <div class="col-12 mt-4">
                      <button type="button"
                        onClick={() => setBoardingpopup(false)} // Close popup when clicked
                        data-toggle="modal" data-target="#BoardingPassPopup" class="btn btn-red px-4 d-block w-100 text-uppercase SerachBtn" >Close</button>
                    </div>

                  </div>
                </div>


              </div>
            </FocusLock>
          </div>
        </div>
      </div>


      {/* ----------------------------------------- new modal popup ends here--------------------------------------------- */}

      {/* ------------------------------------------------------- Uncheck passenger model ----------------------------------- */}
      <FocusLock disabled={!modalShow}>
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="clsSearchModal"
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              What would you like to do ?
            </Modal.Title>
          </Modal.Header>
          <FocusLock>
            <Modal.Body>
              <div class="col-12 mt-4">
                <div class="form-group sp-formField sp-selected">
                  <span class="label">Please select passenger to uncheck</span>
                  <MultiSelect
                    options={passengersListToUncheck}

                    value={selectedPassengerDropdown}
                    onChange={(e) => fncPassengerChangeDropdown(e)}
                    labelledBy="Select the Passenger(s)"
                    className="form-control input-box focusClass"
                    onMenuToggle={(isOpen) => setIsDropdownOpen(isOpen)} // Track dropdown state
                    ItemRenderer={({ checked, option, onClick, index }) => (
                      <div className="custom-option focusClass" key={option.value}>
                        <label>
                          <input
                            id='multiselectinput'
                            type="checkbox"
                            className="checkbox-input input-box" // Ensuring correct class application
                            checked={checked}
                            onChange={onClick}
                            ref={(el) => {
                              passengerRef.current[index] = el;
                            }}
                            onKeyDown={(event) => handleKeyDown(event, index, passengerRef)} // Key navigation support
                          />
                          {option.label}
                        </label>
                      </div>
                    )}
                  />

                </div>
              </div>
              {selectedPassengerDropdown.length > 0 ?
                <div className="row">
                  {
                    st_UnCheckPassenger.map((cp, j) =>
                      cp.Id == "REMOVEBAGS" && CheckInBags == true ? "" :
                        <div className="col-12">
                          <input className="checkbox-input input-box" type="checkbox"
                            checked={cp.IsChecked}
                            id={cp.Id}
                            disabled={cp.IsDisabled}
                            onChange={(e) => { fncSelectUncheckOption(e, cp.Id) }}
                          />
                          {cp.Name}
                        </div>
                    )
                  }
                </div> : null
              }
            </Modal.Body>
            <Modal.Footer>
              <button class="focusClass btn text-nowrap btn-red OrangeShadow" onClick={fncUndoCheckInPassenger} disabled={UnCheckButton}>Ok</button>

              <button class="focusClass btn text-nowrap btn-red OrangeShadow" onClick={handleCloseshowErrorPopup}>Cancel</button>
            </Modal.Footer>
          </FocusLock>
        </Modal>
      </FocusLock>
      {/* ------------------------------------------------ uncheck passenger ends here ------------------------------- */}

    </div>
  );
}

export default Finalize;